<template>
  <v-container fluid>
    <!-- currentStops:{{ currentService.shipment_stop }}
    {{ currentService.shipment_stop ? currentService.shipment_stop.length : 0 }}
    customer address:{{
      shipment && shipment.customer ? shipment.customer.address : ""
    }} -->
    <!-- currentModel:{{ currentModel }} -->
    <!-- currrentSchema:{{ currentSchema }} -->
    <div v-if="!$vuetify.breakpoint.lgAndUp">
      <h4
        v-if="
          companySelected &&
            shipment &&
            shipment.shipment_detail &&
            shipment.shipment_detail.company
        "
      >
        {{ shipment && shipment.shipment_detail.company.company_name }}
      </h4>

      <div class="pa-2" v-if="shipmentId">
        Shipment #: {{ shipmentId }}
        <span class="pa-2 service-type">
          {{
            currentService
              ? capitalize(currentService.service_type) +
                  " " +
                  currentService.service_date || currentService.service_date
              : ""
          }}
        </span>

        &nbsp;
        <!-- <v-spacer></v-spacer> -->
        <span
          class="pa-2"
          :style="{
            backgroundColor: getStatusColor(),
            color: $root.ajustColor(getStatusColor()),
          }"
        >
          {{
            shipment && shipment.shipment_detail
              ? shipment.shipment_detail.status
              : ""
          }}
        </span>
        <!-- {{ serviceType }}
        {{ mileage ? mileage + " miles" : "" }} -->
      </div>
    </div>
    "
    <v-toolbar style="position: sticky; top: 0" flat v-if="!$root.customerId">
      <div v-if="$vuetify.breakpoint.lgAndUp">
        <h4
          v-if="
            companySelected &&
              shipment &&
              shipment.shipment_detail &&
              shipment.shipment_detail.company
          "
        >
          {{ shipment.shipment_detail.company.company_name }}
        </h4>
        <v-spacer></v-spacer>
        <h4 class="pa-2" v-if="shipmentId">
          Shipment #: {{ shipmentId }}
          <span class="pa-2 service-type">
            {{
              currentService
                ? capitalize(currentService.service_type) +
                    " " +
                    currentService.service_date || currentService.service_date
                : ""
            }}
          </span>
          <span
            class="pa-2"
            :style="{
              backgroundColor: getStatusColor(),
              color: $root.ajustColor(getStatusColor()),
            }"
          >
            {{
              shipment && shipment.shipment_detail
                ? shipment.shipment_detail.status
                : ""
            }}
          </span>
          <!-- {{ serviceType }}
        {{ mileage ? mileage + " miles" : "" }} -->
        </h4>
        <v-spacer></v-spacer>
      </div>
      <div class="ml-auto">
        <v-tabs
          class="dense-tabs"
          v-if="shipmentId"
          v-show="!allReadOnly"
          v-model="currentTab"
        >
          <v-tab
            v-for="(item, i) in toolBarControls"
            @click="showPanel(item)"
            :key="i"
            ><v-icon :small="!$vuetify.breakpoint.lgAndUp" class="ma-2">{{
              "mdi-" + item.icon
            }}</v-icon
            ><span v-if="$vuetify.breakpoint.lgAndUp">{{
              item.text
            }}</span></v-tab
          >
          <v-tab>
            <v-menu-button
              v-if="lettersReady"
              v-show="!allReadOnly"
              id="letters"
              :displayTable="true"
              :hasSearch="true"
              :key="letterKey"
              searchLabel="Search Letters"
              v-bind="letterMenuBtn"
            ></v-menu-button>
          </v-tab>
        </v-tabs>
      </div>
      <v-btn text @click="refreshData()" small>
        <v-icon class="mt-n3 ma-lg-2" :small="!$vuetify.breakpoint.lgAndUp"
          >mdi-reload</v-icon
        ><span v-if="$vuetify.breakpoint.lgAndUp">Refresh Data</span></v-btn
      >
    </v-toolbar>
    <div
      :class="{ blurred: loading }"
      style="border: 1px solid #ccc; position: relative"
    >
      <v-alert
        type="warning"
        v-if="openShipment"
        v-html="openShipment"
      ></v-alert>
      <v-dialog v-model="itemDialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h5"> Confirm Item Handling </v-card-title>
          <v-card-text>{{ handlingPrompt }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="applyHandling"> Yes </v-btn>
            <v-btn
              color="danger"
              text
              @click="
                itemDialog = false;
                currentItemHandlingId = null;
              "
            >
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <div v-if="loading">
      <v-loader
        :loadingElements="loadingElements"
        :text="loadingText"
      ></v-loader>
    </div> -->
      <v-dialog v-model="letterReady" max-width="80%">
        <v-document
          ref="doc"
          v-if="letterReady"
          v-bind="letterBind"
          :key="docKey"
        ></v-document>
      </v-dialog>
      <v-movable-dialog
        ref="moveDialog"
        :close="closeVisualInventory"
        title="Visual Inventory"
        v-if="showVisualInventory"
      >
        <!-- Your custom content here -->

        <visual-inventory
          v-if="!$root.customerId"
          :customer="
            shipment.customer.contact.first_name +
              ' ' +
              shipment.customer.contact.last_name
          "
          :client_id="shipment.customer.calltools_contact_id"
          :email="shipment.customer.contact.email"
          :customerPhone="
            shipment.customer.contact.phones.mobile
              ? shipment.customer.contact.phones.mobile.phone_number
              : ''
          "
          :company="getCompanyName()"
          :companyId="company.company_id"
          :company_id="company._id"
          :comp="true"
          :sendMail="$root.sendMail"
          :sendSMS="$root.sendSMS"
          :uploadVideo="uploadVideo"
          :serverUrl="serverURL"
        ></visual-inventory>
      </v-movable-dialog>
      <!-- :style="{ height: mainPanelWidth() }" -->
      <div
        ref="mainPanel"
        :style="{ height: mainPanelHeight(), overflow: 'auto' }"
        class="pa-4 main-panel"
      >
        <!-- company:{{ company }} -->

        <v-form-component
          v-if="multiCompany && !companySelected && !shipmentId"
          :model="selectedCompany"
          :schema="companySchema"
        ></v-form-component>
        <v-btn
          color="info"
          v-if="multiCompany && !companySelected"
          @click="selectCompany"
          >Continue
        </v-btn>
        <v-row>
          <v-col>
            <v-expansion-panels
              flat
              dense
              v-if="companySelected && shownSteps.length"
              v-model="panelIndex"
              @change="panelChange(panelIndex)"
            >
              <v-expansion-panel
                dense
                :disabled="panelDisabled(i)"
                v-for="(item, i) in shownSteps"
                :key="i"
              >
                <v-expansion-panel-header hide-actions>
                  <v-row>
                    <v-col>
                      <v-btn
                        class="justify-start pl-0"
                        text
                        :color="panelIndex === i ? 'info' : ''"
                      >
                        <div
                          class="d-flex ma-lg-2 ml-n2 align-center justify-center rounded-circle white--text"
                          :style="iconSize"
                          :class="getIconColor(item)"
                        >
                          <v-icon
                            :small="!$vuetify.breakpoint.lgAndUp"
                            color="white"
                            class="ma-2"
                            >{{ "mdi-" + item.icon }}</v-icon
                          >
                        </div>
                        <span
                          class="info-title"
                          v-if="panelIndex === i"
                          v-html="item.title"
                        ></span>
                        <span
                          class="item-title"
                          v-if="panelIndex != i"
                          v-html="item.title"
                        ></span
                        >: &nbsp;
                        <div v-if="panelIndex != i" class="float-container">
                          <div
                            class="pl-2 info-label text-info"
                            v-html="item.info || '(not set)'"
                          ></div>
                        </div>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="elevation-3 pa-3">
                  <div class="pa-2">
                    <!-- currentModel:{{ currentModel }} -->
                    <!-- {{ currentSchema }} -->
                    <!-- schemaProperties:{{ schemaProperties }} -->
                    <v-form ref="form">
                      <v-form-component
                        v-if="modelReady"
                        :key="formKey"
                        :parentModel="shipment"
                        :schema="currentSchema"
                        :model="currentModel"
                        :vModel="currentModel"
                      ></v-form-component>
                      <!-- item.additionalControl:{{ item.additionalControl }} -->
                      <!-- <div
                :key="addControlKey"
                v-if="modelReady && item.additionalControl"
              > -->
                      <!-- item.additionalModel {{ item.additionalModel }} -->
                      <v-form-component
                        v-if="
                          modelReady &&
                            ((item.additionalControl && readOnly) ||
                              (item.additionalControl &&
                                item.additionalControl.add_option_object))
                        "
                        :model="item.additionalModel"
                        :vModel="item.additionalModel"
                        :schema="item.additionalControl"
                        :key="addControlKey"
                      ></v-form-component>
                      <!-- </div> -->

                      <!-- <div v-if="item.additionalSchema">

                <v-form-component
                  :vModel="item.model"
                  :model="item.model"
                  :schema="item.additionalSchema"
                  :parentModel="shipment"
                ></v-form-component>


                <div v-if="item.additionalControl">
                  <v-form-component
                    :model="item.additionalControl"
                    :schema="item.additionalControl"
                  ></v-form-component>
                </div>
              </div> -->
                    </v-form>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- <v-col :cols="mapCols" v-if="mapReady" class="ma-2">
            <v-here-map
              :key="mapKey"
              :hideToolbar="false"
              :mapHeight="mapHeight - 350"
              :mapWidth="mapWidth"
              :mapData="mapData"
              ref="hereMap"
            ></v-here-map
          ></v-col> -->
        </v-row>

        <v-app-bar bottom app dense>
          <v-col class="text-center" cols="12">
            <v-alert
              class="ma-2"
              dismissible
              dense
              timeout="3000"
              v-if="errorMessage"
              type="error"
            >
              {{ errorMessage }}
            </v-alert>

            <v-row flat v-if="companySelected">
              <v-col>
                <v-btn
                  right
                  :text="false"
                  :loading="loading"
                  @click="submit(null, true)"
                  color="success"
                  class="save-button ma-2"
                >
                  <v-icon class="ma-2">{{ saveButtonIcon }}</v-icon>
                  {{ saveButtonCaption }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-app-bar>
      </div>
      <!-- Sliding Panel -->
      <transition name="slide-panel">
        <div
          elevation-5
          v-if="dialog"
          class="panel mr-4"
          :style="{ width: panelWidth + 'px' }"
        >
          <v-divider></v-divider>
          <v-container class="panel-form"
            ><v-icon small class="close-btn" @click="dialog = 0"
              >mdi-arrow-collapse-right</v-icon
            >
            <div v-if="dialog" :width="dialogWidth" class="pa-2">
              <v-form-component
                v-if="modelReady && !letterReady"
                :parentModel="shipment"
                :key="formKey"
                :model="currentModel"
                :vModel="currentModel"
                :schema="currentSchema"
                :data_object="{
                  model: model,
                  schema: schema,
                  _id: shipment._id,
                }"
              ></v-form-component>

              <v-here-map
                v-if="mapReady"
                :key="mapKey"
                :hideToolbar="false"
                :mapHeight="mapHeight - 420"
                :mapWidth="mapWidth"
                :mapData="mapData"
                ref="hereMap"
              ></v-here-map>
            </div>
          </v-container>
        </div>
      </transition></div
  ></v-container>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import * as fun from "../plugins/common";
import axios from "axios";
export default {
  name: "Shipment",
  components: {
    VDocument: () => import("../components/Document.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VFormComponent: () => import("../components/FormComponent.vue"),
    VMovePlan: () => import("../components/MovePlan.vue"),
    VCombo: () => import("../components/ComboBox.vue"),
    VShipmentMenuItems: () => import("../components/ShipmentMenuItems.vue"),
    VisualInventory: () => import("../components/VisualInventory.vue"),
    VLabelButton: () => import("../components/LabelButton.vue"),
    VLoader: () => import("../components//UI/Loader.vue"),
    VTakePhoto: () => import("../components/TakePhoto.vue"),
    VMovableDialog: () => import("../components/MovableDialog.vue"),
    VFormCard: () => import("../components/FormCard.vue"),
    VHereMap: () => import("../components/HereMap.vue"),
  },
  props: {},
  data() {
    return {
      schemaProperties: null,
      openShipment: "",
      mapCols: null,
      dialogWidth: 0,
      lettersReady: false,
      allReadOnly: false,
      shipmentObject: null,
      mapData: [],
      unparsedAddresses: [],
      mapHeight: 0,
      foreman: false,
      mapWidth: 0,
      loadingElements: [document.getElementsByClassName("row")[0]],
      loadingText: "Loading...",
      loading: false,
      mapReady: false,
      allLocations: [],
      currentTab: null,
      letterReady: false,
      letterBind: null,
      selectedCompany: {
        shipment_detail: {},
      },
      defaultDialog: {
        text: "CRM",
        icon: "mdi-face-agent",
        hideIfForeman: true,
      },
      addControlKey: 0,
      companyName: "",
      multiCompany: true,
      companySelected: false,
      companySchema: null,
      companyModel: null,
      serviceType: "",
      panelHeader: "",
      serviceIndex: 0,
      mileage: "",
      handlingPrompt: "",
      inventoryTable: null,
      shipmentId: "",
      saveButtonIcon: "mdi-check",
      saveButtonCaption: "Submit",
      shipment: {},
      additionalModel: {},
      itemDialog: false,
      schemaReady: false,
      panelIndex: -1,
      formKey: 0,
      modelReady: false,
      noValidate: false,
      company: null,
      numItems: 0,
      currentStopType: "",
      showVisualInventory: false,
      mainService: null,
      currentService: null,
      dialog: false,
      menuItem: null,
      eventAssigned: false,
      readOnly: false,
      formContainer: {},
      originalModel: null,
      modifiedRecords: [],
      moreData: null,
      totalEstimate: 0,
      balance: 0,
      warehouseAddresses: [],
      shownSteps: [],
      panelOpen: true, // Panel open by default
      panelType: "notes", // Default panel content
      crmTypes: [
        {
          caption: "Actions",
          name: "type",
          value: "action",
          color: "blue",
          hiddenHeaders: ["status"],
        },
        {
          caption: "Notes",
          name: "type",
          value: "note",
          color: "black",
          hiddenHeaders: ["action", "action_date_time", "status"],
          renameHeaders: [
            {
              description: "Note",
            },
          ],
        },
        {
          caption: "History",
          name: "type",
          value: "history",
          color: "red",
          hiddenHeaders: ["action", "action_date_time", "status"],
        },
        {
          caption: "Status Changed",
          name: "type",
          value: "status",
          color: "green",
          hiddenHeaders: ["action", "action_date_time"],
        },
      ],
      wizardSteps: [
        {
          icon: "account-outline",
          id: "customer",
          obj: "customer",
          objectName: "customer",
          schema: {
            contact: {
              password: { hidden: true },
              note: { hidden: true },
            },
            comments: { hidden: true },
            link: { hidden: true },
            address: { hidden: true },
            credit_card: { hidden: true },
          },
          title: "Customer",
          foremanReadOnly: true,
        },
        // {
        //   icon: "account-details",
        //   id: "order_detail",
        //   obj: "order_detail",
        //   objectName: "shipment",
        //   title: "Order Detail",
        //   onlyFields: ["shipment_number"],

        // },
        {
          icon: "home-export-outline",
          id: "pickup",
          obj: "pickup",
          objectName: "address",
          title: "Pickup",
          foremanReadOnly: true,
        },
        {
          icon: "home-import-outline",
          id: "dropoff",
          obj: "dropoff",
          objectName: "address",
          title: "Dropoff",
          foremanReadOnly: true,
        },
        {
          id: "job",
          icon: "truck",
          obj: "job",
          tab: 1,
          objectName: "shipment_service",
          title: "Jobs Schedule",
          foremanReadOnly: true,

          onlyFields: [
            "service_date",
            "pickup_date_range",
            "delivery_date_range",
            // "suggested_cojobs",
          ],
        },
        // {
        //   id: "additional_services",
        //   icon: "human-dolly",
        //   obj: "additional_services",
        //   objectName: "additional_services",
        //   title: "Additional Services",

        //   // onlyFields: [
        //   //   "service_date",
        //   //   "pickup_date_range",
        //   //   "delivery_date_range",
        //   //   // "suggested_cojobs",
        //   // ],
        // },
        {
          icon: "sofa-outline",
          id: "inventory",
          obj: "inventory",
          objectName: "inventory",
          title: "Inventory",
          // schema: {
          //   service_date: {
          //     hideInTable: true,
          //   },
          // },
        },
        {
          icon: "human-dolly",
          id: "resources",
          obj: "resources",

          objectName: "shipment_service",
          title: "Resources Requested",
          onlyFields: ["resources"],
          hidden: this.$root.customerId,
          hideIfForeman: true,
        },
        {
          icon: "calendar-edit",
          id: "onsite_estimate",
          obj: "onsite_estimate",
          objectName: "onsite_estimate",

          tab: 0,
          title: "Onsite Estimates",
          hidden: this.$root.customerId,
          hideIfForeman: true,
        },
        {
          icon: "calculator-variant-outline",
          id: "estimate",
          obj: "estimate",
          objectName: "shipment_service",

          tab: 0,
          title: "Estimated Charges",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          onlyFields: ["estimate_charges", "flat_rate", "is_flat_rate", "rate"],
        },
        {
          icon: "details",
          id: "details",
          obj: "details",
          objectName: "shipment_service",
          title: "Job Details",
          hidden: this.$root.customerId,
          onlyFields: [
            "special_instructions",
            "status",
            "service_type",
            "shipment_stop",
          ],
          // schema: {
          //   service_date: {
          //     hideInTable: true,
          //   },
          // },
        },
        // {
        //   icon: "email-multiple-outline",
        //   id: "letters",
        //   obj: "shipment_service",
        //   objectName: "shipment_service",
        //   title: "Letters and  Documents",
        // },
        {
          icon: "cash-multiple",
          id: "payment",
          obj: "payment",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          objectName: "payment",
          title: "Payment",
        },
        {
          icon: "calendar-multiple-check",
          id: "booking",
          obj: "booking",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          objectName: "shipment_service",
          onlyFields: ["booked", "booked_by", "booked_date"],
          title: "Booking",
        },
        {
          icon: "truck-delivery",
          id: "itinerary",
          obj: "itinerary",
          // hidden: true,
          objectName: "itinerary",
          hideIfForeman: true,
          // onlyFields: ["booked", "booked_by", "booked_date"],
          title: "Itinerary",
        },
        {
          icon: "store-clock",
          id: "crew_employee",
          obj: "crew_employee",
          objectName: "crew_employee",
          hidden: true,
          // schema: {
          //   contact: {
          //     password: { hidden: true },
          //     note: { hidden: true },
          //   },
          //   comments: { hidden: true },
          //   link: { hidden: true },
          //   address: { hidden: true },
          //   credit_card: { hidden: true },
          // },
          title: "Employee Hours",
        },
      ],
      //      <v-btn text>Letters and Documents</v-btn>
      // <v-btn text>CRM</v-btn>
      // <v-btn text>Attachments</v-btn>
      toolBarControls: [
        // { text: "Letters and Documents", icon: "mdi-email-multiple-outline" },
        { text: "CRM", icon: "face-agent", hideIfForeman: true },
        { text: "Attachments", icon: "attachment" },
        { text: "Order Detail", icon: "account-details", hideIfForeman: true },
        { text: "Map", icon: "map", hideIfForeman: false },
      ],
      letterKey: 0,
      letterMenuBtn: null,
      fixedModel: null,
      defaultModelClone: null,
      customerSchema: null,
      activate: false,
      fullscreen: false,
      defaultModel: {
        customer: {
          type_of_customer: "residential",
          contact: {
            // first_name: "Yuri",
            // last_name: "Frid",
            // email: "y@f.com",
            phones: {
              mobile: {
                type: "mobile",
              },
            },
          },
          address: [],
        },
        inventory: [],
        num_items: 0,
        // shipment_detail: {
        //   company: "1d023118cc43086f105ee3ac",
        // },
        stops: [],
        payment: [],
        estimate: {
          "non-binding": {
            shipment_service: [
              {
                // service_type: "long_distance_moving",
              },
            ],
          },
        },
        attachments: {},
      },
      schema: {},
      currentObject: "",
      obj_name: "shipment",
      newShipment: true,
      calculated: false,
    };
  },
  activated() {
    //
    if (!this.activate) {
      if (!this.$router.currentRoute.params.id) {
        // this.init();
        this.shipmentId = null;
        this.assignEvents();
        // this.$router.go(0);
        this.$router.replace({
          path: this.$route.path,
          query: this.$route.query,
        });
      } else {
        if (!this.shipment.customer._id) {
          this.panelIndex = -1;
          this.refreshData();
        }
        //
      }
    }

    // console.log(this.shipmentId);
    if (this.$refs.hereMap) {
      this.$refs.hereMap.initMap();
    }
  },
  // created() {
  //   this.assignEvents();
  // },
  mounted() {
    this.mount();
  },
  beforeDestroy() {},
  methods: {
    mainPanelHeight() {
      // this.$nextTick(() => {
      // if (this.$refs.mainPanel) {
      //   return this.$refs.mainPanel.getBoundingClientRect().height + "px";
      // }
      return "67vh";
      // });
    },
    mount() {
      var that = this;
      this.loading = true;
      window.onAddressChange = this.onAddressChange;

      this.activate = true;
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.currentTab = 0;
      } else {
        this.currentTab = 4;
      }

      if (this.$root.roles.includes("foreman")) {
        this.foreman = true;
      }
      if (this.foreman) {
        this.toolBarControls = this.toolBarControls.filter((t) => {
          return !t.hideIfForeman;
        });
      }
      // this.loadWizard();
      this.mapHeight = window.innerHeight - 80;
      if (fun.isMobile()) {
        this.mapWidth = window.innerWidth - 10;
        this.dialogWidth = window.innerWidth - 10;
      } else {
        this.dialogWidth = screen.width;
        this.mapWidth = window.innerWidth * 0.6;
      }

      // this.mapReady = true;
      this.assignEvents();
      this.eventAssigned = true;

      this.init();
      this.refreshData();
      if (!this.defaultModelClone) {
        this.defaultModelClone = fun.clone(this.defaultModel);
      }
    },
    checkPermissions() {
      var permittedActions = this.$root.store.permittedActions;
      // var filterJobs = false;
      // var noBooked = false;
      // var filterCompany = false;
      var that = this;
      if (permittedActions) {
        permittedActions.forEach((a) => {
          console.log(a);
          if (
            a.read_only_unassigned &&
            that.$root.user_email !=
              that.shipment.shipment_detail.sales_person.email
          ) {
            this.allReadOnly = true;
          }
        });
      }
      if (this.allReadOnly) {
        this.getWizardStep("details").onlyFields = [
          "special_instructions",
          "status",
          "service_type",
        ];
      }
    },
    uploadVideo(data) {
      var that = this;
      data.append("object_name", "shipment");
      data.append("record_id", this.shipment.shipment_id);
      data.append("dropbox", true);
      data.append(
        "portal",
        "portal_" + this.$store.state.auth.portal.portal_id
      );

      axios.post(this.serverURL + "/upload_file", data);
      that.successMessage =
        "Video has been sent to dropbox. It make take few minites to finish uploading";
    },
    calculateSize(obj, path) {
      // Function to safely access a nested property
      const getNestedProperty = (obj, pathArray) => {
        return pathArray.reduce(
          (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
          obj
        );
      };

      try {
        // Ensure the path is an array
        const pathArray = typeof path === "string" ? path.split(".") : path;

        // Get the target object
        const targetObject = getNestedProperty(obj, pathArray);

        if (targetObject === undefined) {
          return "Property does not exist";
        }

        // Calculate the size of the object
        const objectSizeInBytes = Buffer.byteLength(
          JSON.stringify(targetObject),
          "utf-8"
        );
        const objectSizeInKB = objectSizeInBytes / 1024;
        console.log(targetObject, objectSizeInKB.toFixed(2));
        // return {
        //   bytes: objectSizeInBytes,
        //   kilobytes: objectSizeInKB.toFixed(2),
        // };
      } catch (error) {
        console.error("Error calculating size:", error);
        return "Error occurred";
      }
    },
    getBiggestObject(response) {
      const jsonData = response.data;
      const jsonString = JSON.stringify(response.data.model[0]);

      // Calculate the size of the string in bytes
      const dataSizeInBytes = Buffer.byteLength(jsonString, "utf-8"); // Size in bytes

      // Convert bytes to kilobytes
      const dataSizeInKB = dataSizeInBytes / 1024;

      console.log(`Model size: ${dataSizeInKB.toFixed(2)} KB`);

      // // Function to get the size of an object
      // const getObjectSize = (obj) =>
      //   Buffer.byteLength(JSON.stringify(obj), "utf-8");

      // let largestObject = null;
      // let largestSize = 0;

      // // Safe way to check if a property exists on an object
      // const hasOwnProperty = (obj, prop) =>
      //   Object.prototype.hasOwnProperty.call(obj, prop);

      // // Iterate through the top-level keys of the JSON object
      // for (const key in jsonData) {
      //   if (hasOwnProperty(jsonData, key)) {
      //     const value = jsonData[key];

      //     // Check if the value is an object or array
      //     if (typeof value === "object" && value !== null) {
      //       const currentSize = getObjectSize(value);
      //       if (currentSize > largestSize) {
      //         largestSize = currentSize;
      //         largestObject = { key, data: value };
      //       }
      //     }
      //   }
      // }

      // console.log(`Largest object/array key: ${largestObject.key}`);
      // console.log(`Size: ${(largestSize / 1024).toFixed(2)} KB`);
      // console.log("Largest object/array:", largestObject.data);
    },
    refreshData() {
      var that = this;
      var url = "";
      var data = {};
      if (
        this.shipmentId &&
        this.$router.currentRoute.params.id.toString().split("_")[0] !=
          this.shipmentId.toString().split("_")[0]
      ) {
        this.shipmentId = this.$router.currentRoute.params.id;
      }

      if (this.shipmentId) {
        this.shipment_id = parseInt(this.shipmentId.toString().split("_")[0]);
        data.qry = {
          shipment_id: parseInt(this.shipmentId),
        };
      }

      url = "get_data";
      data.object_name = "shipment";
      // data.schema_name = "shipment";

      var addData = {
        additional_data: [
          {
            obj_name: "v_open_shipments",
            schema_name: "open_shipment",
            qry: { shipment_id: this.shipmentId },
          },
          {
            obj_name: "company",
            qry: { $or: [{ active: true }, { active: { $exists: false } }] },
          },
          {
            obj_name: "charge_list",
          },
          {
            obj_name: "material_list",
          },
          {
            obj_name: "service_type",
          },
          {
            obj_name: "vehicle_type",
          },
          {
            obj_name: "employee_role",
          },
          {
            obj_name: "resource_type",
          },
          {
            obj_name: "charge_category",
          },
          {
            obj_name: "delivery_status",
          },
          {
            obj_name: "room",
          },
          {
            obj_name: "task",
          },
          {
            obj_name: "employee",

            qry: {
              _id: this.$root.user_id,
            },
          },

          {
            obj_name: "warehouse",
          },
          {
            obj_name: "v_sent_letters",

            qry: {
              shipment_id: parseInt(this.shipment_id),
            },
          },
          {
            obj_name: "zone",

            fields: [
              "_id",
              "zone_name",
              "states",
              "counties",
              "cities",
              "movetype",
              "type",
            ],
          },
          {
            obj_name: "agent",
            // qry: {
            //   type: "tariff_zone",
            // },
            fields: ["_id", "contact", "zones", "has_own_tariff"],
          },
          {
            obj_name: "stage",
          },
          {
            obj_name: "rate_list",
            data_name: "labor_rates",
            qry: {
              charge_type: "transportation_hourly_based",
            },
          },
          {
            obj_name: "lead_status",
          },
        ],
        // additional_structure: [
        //   {
        //     obj_name: "charges",
        //   },
        //   {
        //     obj_name: "shipment_service",
        //   },
        //   {
        //     obj_name: "storage",
        //   },
        // ],
      };

      data = {
        ...data,
        ...addData,
      };
      // }
      // } else {
      //   url = "get_schema";
      //   data.obj_name = "shipment";
      //   this.panelIndex = 0;
      // }
      if (this.shipmentId) {
        // data.get_more = [
        //   {
        //     object_name: "shipment",
        //     qry_fn:
        //       "{'customer':json.loads(return_data).get('model')[0].get('customer').get('_id')}",
        //     fields: ["shipment_id", "stops"],
        //     id_fields: ["customer"],
        //   },
        // ];
      }
      console.time("Axios Request"); // Start the timer
      axios
        .post(this.serverURL + "/" + url, data, {
          withCredentials: true,
        })
        .then((response) => {
          console.timeEnd("Axios Request");
          this.activate = false;
          this.loading = false;

          this.getBiggestObject(response);
          // this.calculateSize(response.data.model[0], [
          //   "estimate",
          //   "non-binding",
          //   "shipment_service",
          //   0,
          //   "route",
          //   "shape",
          // ]);

          this.additionalModel = response.data.additional_model;
          this.openShipment = "";
          if (this.additionalModel.v_open_shipments.length) {
            var opened = this.additionalModel.v_open_shipments[0];

            if (
              opened.action == "open" &&
              opened.user &&
              opened.user != this.$root.store.userData.email
            ) {
              var user =
                this.$root.store.userData.first_name +
                " " +
                this.$root.store.userData.last_name;
              this.openShipment =
                "This shipment is currently open by " +
                user +
                " (" +
                this.$root.store.userData.email +
                ") <br/> Any changes you will make may be overwritten";
            }
            console.log(this.openShipment);
          }

          this.moreData = response.data.more_data;

          that.schema.properties = response.data.schema;

          this.additionalModel = response.data.additional_model;

          if (this.shipmentId) {
            try {
              if (
                this.$router.currentRoute.params.id.toString().split("_")[1]
              ) {
                var currentServiceId = this.$router.currentRoute.params.id
                  .toString()
                  .split("_")[1];
                that.shipment.estimate["non-binding"].shipment_service.forEach(
                  (s, i) => {
                    if (s._id == currentServiceId) {
                      this.serviceIndex = i;
                      this.currentService = s;
                    }
                  }
                );
              }
            } catch {
              //
            }
            this.shipment = response.data.model[0];

            if (this.shipment && !this.shipment.inventory) {
              this.shipment.inventory = [];
            }
            if (
              (this.shipment && !this.shipment.crm) ||
              (this.shipment && !this.shipment.crm.length)
            ) {
              var crm = {
                type: "status",
                description: "Estimate Created",
                status: "new",

                time_stamp: that.shipment.shipment_detail
                  ? that.shipment.shipment_detail.order_date_time
                  : "",
              };
              this.shipment.crm = [crm];
            }
            if (!this.shipment.onsite_estimate) {
              this.shipment.onsite_estimate = [];
            }
            this.currentService = this.shipment.estimate[
              "non-binding"
            ].shipment_service[this.serviceIndex];
            console.log("route", this.currentService.route);
            this.populateDefaultAddresses();
            this.loadWizard();
            this.createStops();
            this.getCompanyName();
            this.checkPermissions();
            this.fixAddresses();
            if (this.$vuetify.breakpoint.lgAndUp) {
              this.showPanel(this.defaultDialog);
            }

            if (
              this.shipment.customer &&
              !this.shipment.customer.type_of_customer
            ) {
              this.shipment.customer.type_of_customer = "residential";
            }

            this.defaultModel = this.shipment;
            if (!this.defaultModel.payment) {
              this.defaultModel.payment = [];
            }

            this.assignCustomerName();
            this.companySelected = true;
            // this.fixAddresses();
            // this.newShipment = false;
            // this.expandPanel({ objectName: "customer" });
            this.updateTitles();
            this.mainService = this.shipment.estimate[
              "non-binding"
            ].shipment_service[0];

            // this.populateLettersMenu(this.shipment.document);
            if (this.shipment.shipment_detail.company) {
              this.getLetters(this.shipment.shipment_detail.company._id);
            }
          } else {
            // that.schema.properties = response.data;

            this.schemaReady = true;
            console.log(response.data);

            // if (!this.shipmentId) {
            that.companySchema = {
              shipment_detail: {
                properties: {
                  company:
                    that.schema.properties.properties.shipment_detail.properties
                      .company,
                },
              },
            };
            //         "getItems": false,
            // "capitalizeText": true,

            // that.company = {
            //   properties: company,
            // };
            var companyVBind =
              that.companySchema.shipment_detail.properties.company["v-bind"];
            companyVBind.getItems = false;
            companyVBind.capitalizeText = true;
            companyVBind.qry = { active: true };
            that.companySchema.shipment_detail.properties.company["x-display"] =
              "v-radio-list";
            // companyVBind.defaultIndex = null;
            that.companySchema.shipment_detail.properties.company.title =
              "Select Company";
            if (!this.shipment) {
              this.shipment =
                fun.clone(this.defaulModelClone) || this.defaultModel;
            }

            this.panelIndex = 0;
            this.expandPanel(this.wizardSteps[0]);

            this.companyModel = this.getModel({
              objectName: "shipment_detail",
            });
          }
          // }
          this.modelReady = true;
        });
    },
    populateDefaultAddresses() {
      if (!this.warehouseAddresses || !this.warehouseAddresses.length) {
        this.warehouseAddresses = [];
        this.additionalModel.warehouse.forEach((w) => {
          this.warehouseAddresses.push(w);
        });
        // fun.clone(this.additionalModel.warehouse);
        var company = this.additionalModel.company[0];
        try {
          this.additionalModel.company.find((c) => {
            return c._id == this.shipment.shipment_detail.company._id;
          });
        } catch (error) {
          //
        }

        if (company) {
          this.warehouseAddresses.push({
            _id: company._id,
            warehouse_name: company.company_name,
            address: company.address ? company.address.address : "",
          });
        }

        this.warehouseAddresses.forEach((w) => {
          try {
            // console.log(w);
            w.full_address = w.address.address;
            w.location = { address: w.address };
            // w.use_existing = true;

            w.existing_address = {
              address_id: w._id,
              value: w.address.address,
              text: w.warehouse_name + " " + w.address.address,
            };
            delete w.address;
          } catch (error) {
            //
          }
        });
      }
      this.getAllLocations();
    },
    loadWizard() {
      var w = this.getWizardStep("crew_employee");

      if (
        this.currentService &&
        this.currentService.itinerary &&
        this.currentService.itinerary[0] &&
        this.currentService.itinerary[0].day_crew
      ) {
        w.hidden = false;
      } else {
        w.hidden = true;
      }

      this.shownSteps = this.wizardSteps.filter((w) => {
        return (
          (!w.hidden && !w.hideIfForeman && this.foreman) ||
          (!this.foreman && !w.hidden)
        );
      });
    },
    closeVisualInventory() {
      this.showVisualInventory = false;
    },
    getCompanyName() {
      if (this.shipment.shipment_detail.company) {
        this.company = this.additionalModel.company.filter((c) => {
          return (
            c._id == this.shipment.shipment_detail.company ||
            c._id == this.shipment.shipment_detail.company._id
          );
        })[0];

        try {
          this.shipment.shipment_detail.company.logo_url = this.company.logo_url;
        } catch (error) {
          //
        }

        if (this.company) {
          return this.company.companyName;
        }
      } else {
        if (!this.company) {
          this.company = {
            _id: this.additionalModel.company[0]._id,
            companyName: this.additionalModel.company[0].company_name,
          };
          return this.company.companyName;
        }
      }
    },
    createStops() {
      this.shipment.stops = [];
      try {
        this.shipment.estimate["non-binding"].shipment_service.forEach((s) => {
          s.shipment_stop.forEach((st) => {
            this.shipment.stops.push(st);
          });
        });
      } catch (error) {
        //
      }
    },
    assignCustomerName() {
      var that = this;
      if (this.shipment.customer.type_of_customer == "residential") {
        this.shipment.customer_name =
          this.shipment.customer.customer_name ||
          this.shipment.customer.contact.first_name +
            " " +
            this.shipment.customer.contact.last_name;
      } else {
        var department = "";
        if (
          !that.shipment.department_id &&
          that.shipment.customer.department?.length == 1
        ) {
          that.shipment.department_id =
            that.shipment.customer.department[0]._id;
        }
        if (that.shipment?.customer.department && that.shipment.department_id) {
          department =
            that.shipment?.customer?.department?.find(
              (d) => d._id == that.shipment.department_id
            )?.department_name ?? "";
          if (department) {
            that.shipment.customer_name =
              that.shipment.customer.company + " -" + department;
          } else {
            that.shipment.customer_name = that.shipment.customer.company;
          }
        }
      }
    },
    findZone(addr) {
      var loc = {};
      var geo = fun.deepFind(addr, "geo");
      if (!geo && addr && addr.address) {
        geo = addr.address.geo;
      }
      if (!geo) {
        return "";
      }
      var location = geo.location.address || geo.location;
      var zone = this.additionalModel.zone;
      var elementInArray = function(array, el) {
        if (!el) return false;
        if (!Array.isArray(array)) {
          array = array.split(",");
        }
        const index = array.findIndex((element) => {
          return (
            !element ||
            element.toString().toLowerCase() === el.toString().toLowerCase()
          );
        });
        return index != -1;
      };

      var myZones = zone.filter((z) => {
        if (z.states) {
          return elementInArray(z.states, location.stateCode);
        }
        if (z.locations) {
          return elementInArray(z.locations, location.stateCode);
        }
      });
      if (myZones.length) {
        myZones = myZones.filter((z) => {
          return (
            !z.counties ||
            !z.counties.length ||
            elementInArray(z.counties, location.county)
          );
        });
      }
      if (myZones.length) {
        myZones = myZones.filter((z) => {
          return (
            !z.cities ||
            !z.cities.length ||
            elementInArray(z.cities, location.city)
          );
        });
      }
      // console.log(myZones);
      if (myZones.length) {
        myZones.forEach((z) => {
          if (z.type == "tariff_zone") {
            loc.zone = {
              zone_name: z.zone_name,
              zone_id: z._id,
            };
          }
          if (z.type == "carrier_zone") {
            loc.carrier_zone = {
              zone_name: z.zone_name,
              zone_id: z._id,
            };
          }
        });
        return loc;
        // if (addr.zone) {
        //   return addr.zone.zone_id;
        // }
      }
    },
    getLetters(companyId) {
      var data = {
        object_name: "document",
        qry: {
          $or: [{ company: companyId }, { company: null }],
        },
      };
      this.loading = true;
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response.data);

          this.populateLettersMenu(response.data.model);
        });
    },
    populateLettersMenu(l) {
      var that = this;
      var items = [];
      l.forEach((d) => {
        if (d.document_name) {
          items.push({
            itemText: d.document_name,
            itemValue: d._id,
          });
        }
      });
      fun.sortObjects(items, "itemText");
      this.letterMenuBtn = {
        title: this.$vuetify.breakpoint.lgAndUp ? "Letters and Documents" : "",
        menuItems: items,
        small: true,
        text: true,
        menuItemClick: this.letterContainer,
        sideModel: this.shipment,
        // color: "yellow",
        // color: "warning",
        icon: "mdi-email",
        closeMenuOnClick: true,
      };
      this.$nextTick(() => {
        this.lettersReady = true;
        this.loading = false;
        this.fullscreen = true;
      });
    },
    showPanel(item) {
      this.mapReady = false;
      this.dialog = false;
      this.menuItem = item;
      this.modelReady = false;
      this.letterReady = false;
      this.panelHeader = item.text;
      this.dialogWidth = screen.width / 2;
      if (item.text == "Map") {
        this.loading = true;
        this.calculateRoute(this.currentService, this.createMapData);
        // this.mapReady = true;
        // this.mapKey = !this.mapKey;
      } else {
        var obj = {
          obj: item.text.toLowerCase(),
          objectName: item.text.toLowerCase(),
        };
        if (item.text == "Order Detail") {
          obj = {
            obj: "shipment_detail",
            objectName: "shipment_detail",
          };
        }

        this.currentModel = this.getModel(obj);

        this.currentSchema = this.getSchema(obj);
        this.formKey = !this.formKey;
        this.modelReady = true;
      }
      this.dialog = true;
      this.panelIndex = -1;
    },
    getPath(object, previousPath) {
      var arrayControls = [
        "d-table",
        "v-charge",
        "v-labor",
        "d-iterator",
        "v-data-time-line",
        "v-collapsible",
      ];
      for (var key in object) {
        let currentPath = previousPath ? `${previousPath}.${key}` : key;
        var v;
        if (object[key].type == "object") {
          v = this.fixedModel[currentPath];
          if (!v) {
            if (arrayControls.includes(object[key]["x-display"])) {
              this.fixedModel[currentPath] = [{}];
            } else {
              this.fixedModel[currentPath] = {};
            }
          }
        }
        if (object[key].properties) {
          this.getPath(object[key].properties, currentPath);
        }
      }
    },
    fixLetterModel() {
      this.fixedModel = this.additionalModel.v_shipment_letter_fields[0];
      try {
        var path = this.getPath(this.schema.properties);
      } catch (error) {
        console.log(error);
      }

      // console.log(path);
      var objects = fun.getObjects(this.schema.properties, "type", "object");
      var objectNames = [];
      objects.forEach((o) => {
        if (o.object_type) {
          objectNames.push(o.object_type);
        }
      });
      objectNames.forEach((n) => {
        var v = fun.getObjectsByKey(this.fixedModel, n);
        if (!v || !v.length) {
          var p = fun.findPath(this.fixedModel, n, v);
          v = {};
        }
      });

      this.fixedModel.total_estimate = this.shipment.total_estimate;
      if (this.shipment.shipment_detail.sales_person) {
        this.fixedModel.shipment_detail.sales_person = this.shipment.shipment_detail.sales_person._id;
      }

      this.fixedModel.balance = (
        this.fixedModel.total_estimate - this.shipment.total_payment
      ).toFixed(2);
      this.letterModel = this.fixedModel;
    },
    prepareChargeList(rec) {
      var that = this;
      rec = rec.filter((record) => {
        // If no company array or it's empty, include the record
        if (!record.company || record.company.length === 0) {
          return true;
        }

        // Check if at least one company._id matches with an _id in mycompany
        return record.company.some(
          (company) => company._id === this.shipment.shipment_detail.company._id
        );
      });
      rec.forEach((r) => {
        switch (r.charge_category) {
          case "labor":
            console.log(r);
            r.delete = r.crew_rate ? true : false;
            r.crew_rate?.forEach((c) => {
              var rate = fun.clone(c.labor_rate);
              rate.forEach((r) => {
                r.qty = 1;
                r.unit = "hour";
                r.rate_name = c.labor_rate_type;
                r;
                // console.log(r);
              });
              rec.push({
                charge_name: c.num_men + " Men " + c.num_truck + " Truck",
                charge_category: r.charge_category,
                rate: rate,
                _id: c._id,
              });
            });
            // if (!r.crew_rate) {
            //   rec.push(r);
            // }

            break;
          case "material":
            r.charge_category = "packing";
            break;

          default:
            // console.log(r);
            break;
        }
      });

      return rec.filter((r) => {
        return !r.delete;
      });
    },
    // menuItemClick(m, d, item) {
    //   var that = this;
    //   // console.log(m);
    //   // this.isClosing = false;
    //   // var obj = {};
    //   // if (m == "closing") {
    //   //   obj = {
    //   //     id: "shipment_service",
    //   //     title: "Job Closing",
    //   //     objectName: "shipment_service",
    //   //   };
    //   //   this.isClosing = true;
    //   //   if (this.dataTabs.length) {
    //   //     this.dataTabs.splice(0, this.dataTabs.length);
    //   //     this.menuItemClick("closing");
    //   //   }
    //   // }
    //   // if (m == "pickup" || m == "dropoff") {
    //   //   obj = this.addExtraStop(m, d);
    //   // }

    //   // if (m == "storage") {
    //   //   obj = { id: "storage" };
    //   // }
    //   // if (m.objectName && m.objectName == "service_type") {
    //   //   obj = this.addCoJob(m);
    //   // }
    //   if (m.id && m.id == "letters") {
    //     obj.isLetter = true;
    //     obj.title = m.item.text;
    //     obj.obj = m;
    //   }

    //   // this.addTab(obj);
    //   this.currentModel = this.getModel(obj);

    //   that.currentSchema = this.getSchema();
    // },
    letterContainer(obj, parent) {
      this.currentTab = 4;
      this.mapReady = false;
      if (!obj) {
        return;
      }
      var that = this;
      var d = obj.obj;
      this.dialogWidth = screen.width;
      this.currentTab = 4;
      // this.getTotalEstimate(this.model);

      var data = {
        object_name: "document",
        qry: {
          _id: obj.item.value,
        },
        additional_data: [
          {
            obj_name: "v_shipment_letter_fields",

            qry: {
              shipment_id: parseInt(this.shipmentId),
            },
          },
        ],
      };
      this.loading = true;
      axios
        .post(that.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          let model = response.data.model;
          if (!this.additionalModel) {
            this.additional_model = {};
          }
          this.additionalModel.v_shipment_letter_fields =
            response.data.additional_model.v_shipment_letter_fields;

          that.fixLetterModel();

          var decoded = fun.decodeHtml(model[0].body);
          var bodyTemplate = fun.replaceLetterFields(decoded);
          if (this.additionalModel.company.length > 1) {
            var company = this.additionalModel.company.filter((c) => {
              return c._id == this.shipment.shipment_detail.company;
            })[0];
          }
          var introBody = model[0].intro_body
            ? fun.replaceLetterFields(model[0].intro_body)
            : "";
          var fixFields = function(b) {
            b = b
              .replaceAll(
                "estimate['non-binding'].shipment_service[0]",
                "service"
              )
              .replaceAll(
                "estimate['non-binding'].shipment_service",
                "services"
              );
            return b;
          };
          that.letterReady = false;
          let shipmentModel = fun.clone(this.shipment);
          shipmentModel.service = this.shipment.estimate[
            "non-binding"
          ].shipment_service[0];

          var email = shipmentModel.customer.contact.email;
          if (shipmentModel.department_id) {
            try {
              var dep = shipmentModel.customer.department.find((d) => {
                return d._id == shipmentModel.department_id;
              });
              email = dep.contact.email;
            } catch (error) {
              //
            }
          }

          this.letterBind = {
            email: email,
            companyId: shipmentModel.shipment_detail.company._id,
            documentId: obj.value,
            model: that.additionalModel.v_shipment_letter_fields[0],
            shipmentModel: shipmentModel,
            documentModel: model[0],
            bodyTemplate: "<div>" + fixFields(bodyTemplate) + "</div>",
            introBodyTemplate: "<div>" + fixFields(introBody) + "</div>",
          };
          // var myTab = that.dataTabs.filter((t) => {
          //   if (t.obj.obj && t.obj.obj.item) {
          //     return t.obj.obj.item.value == d.item.value;
          //   }
          // });
          // if (myTab.length) {
          //   myTab[0].letterBind = obj.letterBind;
          // }
          that.letterReady = true;
          that.loading = false;
          this.dialog = true;
          that.docKey = !that.docKey;
        })
        .catch((reason) => {
          // errorsHandler(reason);
        });
    },
    populateLetter(obj) {
      var that = this;
      this.data = {
        object_name: "document",
        qry: {
          _id: obj.value,
        },
        additional_data: [
          {
            obj_name: "v_shipment_letter_fields",

            qry: {
              shipment_id: parseInt(that.shipmentId),
            },
          },
        ],
      };

      axios
        .post(that.serverURL + "/get_data", this.data, {
          withCredentials: true,
        })
        .then((response) => {
          var bodyTemplate = "";
          let documentModel = response.data.model;
          // bodyTemplate = r;
          that.shipment.service_type = "";
          let model = fun.clone(this.shipment);
          model.service =
            that.shipment.estimate["non-binding"].shipment_service[0];
          model.company = that.shipment.shipment_detail.company;

          this.letterBind = {
            email: model.customer.contact.email,
            documentId: obj.value,
            eMailSubject: documentModel[0].email_subject,
            model: that.shipment,
            documentModel: documentModel[0],
            letterId: documentModel[0]._id,
            bodyTemplate: "<div>" + documentModel[0].body + "</div>",
          };
          this.letterReady = true;
          this.dialog = true;

          // this.$root.getObjectStructure(
          //   "translate/letter_fields.json",
          //   model[0].body,
          //   (r) => {

          //   }
          // );
        })
        .catch((reason) => {
          // errorsHandler(reason);
        });
    },
    getCustomerAddresses(customerId, commit) {
      var data = {
        object_name: "customer",
        qry: {
          _id: customerId,
        },
      };
      try {
        axios
          .post(this.serverURL + "/get_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            // console.log(response.data);

            this.data = response.data.model[0].address;
            commit(response.data);
          });
      } catch (err) {
        this.error = err.response?.data?.message || "An error occurred";
      } finally {
        this.loading = false;
      }
    },
    assignEvents() {
      var that = this;
      if (this.eventAssigned) {
        return;
      }
      //tabUpdated
      // this.$root.$on("tabUpdated", d => {
      //   if (d && d == that.shipmentId) {
      //     that.refreshData(d);
      //   }
      // });
      this.$root.$on("rowAdded", (d) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }

        if (
          d.tbl.parentModel &&
          d.tbl.parentModel.shipment_id != that.shipment.shipment_id
        ) {
          return;
        }
        if (d.tbl.tableName == "Resources") {
          // that.expandPanel({ obj: "resources" });
          // that.panelChange();
          // that.panelChange(5);
        }
        if (
          d.tbl.tableName == "inventory" &&
          fun.getParentByProperty(d.tbl, "newShipment")
        ) {
          if (!d.rec.item.qty) {
            d.rec.item.qty = 1;
          }
          if (!d.rec.item.volume) {
            d.rec.item.volume = 1;
            d.rec.total_volume = 1;
          }
          // that.shipment.inventory = d.tbl.originalRecords.length
          //   ? d.tbl.originalRecords
          //   : d.tbl.table;
          that.shipment.inventory = d.tbl.table;
          if (d.tbl.tableName == "inventory" && d.row && d.row.item) {
            var tableObject = d.tbl;
            that.inventoryTable = tableObject;
            that.inventoryTable.menuOpen = true;
            try {
              if (!d.row.room) {
                d.row.room = d.tbl.$refs.selectRoom[0].model;
              }
            } catch (error) {
              //
            }
            if (
              that.shipment.estimate["non-binding"].shipment_service.length == 1
            ) {
              d.row.service_date =
                that.shipment.estimate[
                  "non-binding"
                ].shipment_service[0].service_date;
            } else {
              d.row.service_date = that.currentServceDate.value;
              //
            }
            // var shipmentStops = that.shipmentStops();

            var pickup = that.shipmentStops().find((s) => {
              return s.value.includes("pickup");
            });

            if (pickup) {
              d.row.from = pickup.full_address;
            }
            var dropoff = that.shipmentStops().find((s) => {
              return s.value.includes("dropoff");
            });
            if (dropoff) {
              d.row.to = dropoff.full_address;
            }
            if (that.shipment.has_storage) {
              d.row.to_storage = true;
            }

            if (fun.deepFind(d, "rec.item.rec.item_handling")) {
              if (this.currentItemHandlingId == d.row._id) {
                return;
              }
              this.currentItemHandlingId = d.row._id;
              var handling = d.rec.item.rec.item_handling;
              // that.inventoryTable.menuOpen = false;
              if (handling.prompt && !tableObject.edited) {
                // console.log(handling.prompt);
                that.handlingPrompt = handling.prompt;
                that.itemDialog = !that.itemDialog;
                this.currentItem = d.row;
                // that.currentItem = obj.formModel;
                that.currentHandling = handling;
              }
              // } else {
            }
            if (d.row.item && d.row.item.startsWith("(CP) ")) {
              d.row.isMaterial = true;
            }
            // that.submit(true, true);
            //
          }
        }

        console.log(d);
      });

      this.$root.$on("get_combo_items", function(combo) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var par = fun.getParentByProperty(combo, "shipmentId");
        if (par.shipmentId != that.shipmentId) {
          return;
        }
        if (combo.k == "estimate_address") {
          if (!combo.comboItems) {
            combo.comboItems = [];
          }
          var addresses = that.shipmentStops();
          var customerAddresses = that.shipment.customer.address.filter(
            (item1) => {
              return addresses.some((item2) => {
                return (
                  item2.address_id === item1._id ||
                  item2.full_address === item1.full_address ||
                  that.cleanFullAddress(item2.full_address) ==
                    that.cleanFullAddress(item1.full_address)
                );
              });
            }
          );

          customerAddresses.forEach((a) => {
            var apt = "";
            if (!a.location) {
              a.location = {};
            }
            if (a.location.apt) {
              apt = " apt " + a.location.apt;
            }
            if (!a.location.address) {
              a.location.address = {};
            }
            var address = a.location.address.address + apt;
            if (address) {
              combo.comboItems.push(address);
            }
          });
        }

        // if (combo.k == "tariff") {
        //   var model = that.data_object.model;

        //   var curTariff = that.data_object.all_tariff.filter(function(t) {
        //     if (t && t.haul_type) {
        //       return t.haul_type.includes(model.shipment_detail.haul_type);
        //     }
        //   });
        //   curTariff.forEach((tar) => {
        //     Object.keys(model.estimate).forEach(function() {
        //       var t = {
        //         text: tar.tariff_name,
        //         value: tar._id,
        //       };
        //       combo.comboItems.push(t);
        //     });
        //   });
        // }

        // if (combo.k == "company") {
        //   combo.comboItems = that.shipmentObject.additionalModel.company;
        // }
      });

      //tabAdded
      this.$root.$on("tabAdded", function(obj) {
        // if (that._uid != that.$root.shipmentUid) {
        //   return;
        // }
        if (
          (obj.shipment_id && that.shipmentId == obj.shipment_id) ||
          (!obj.shipment_id && !that.shipmentId)
        ) {
          that.init();
        }
      });
      //tableItemChanged
      this.$root.$on("tableItemChanged", function(obj) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.itemName == "service_hours") {
          that.currentModel.crew_employee = obj.tbl.table;
        }
        console.log(obj);
      });
      this.$root.$on("comboUpdated", function(obj) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        const ignoreObjects = [
          "charge_category",
          "v_estimator",
          "v_employee",
          "employee_role",
        ];
        if (obj.objName && ignoreObjects.includes(obj.objName)) {
          return;
        }
        // if (obj.objName && obj.objName == "v_estimator") {
        //   return;
        // }
        // if (obj.objName && obj.objName == "v_employee") {
        //   return;
        // }
        if (
          !obj.obj.parentModel ||
          obj.obj.parentModel.payment ||
          obj.obj.parentModel.inventory
        ) {
          return;
        }
        if (
          obj.obj.parentModel &&
          !obj.obj.parentModel.onsite_estimate &&
          obj.obj.parentModel.shipment_id != that.shipment.shipment_id
        ) {
          var service =
            that.shipment.estimate["non-binding"].shipment_service[
              that.serviceIndex
            ];

          var curStop = obj.formModel;
          if (obj.item) {
            curStop.address_id = obj.item.address_id;
            that.addShipmentStop("", "", obj.item.address_id, curStop);
          }

          that.panelIndex = -1;
          that.updateTitles();
        }

        console.log(obj);
      });
      this.$root.$on("itemsDeleted", (obj) => {
        if (obj.tableName == "shipments") {
          obj.selected.forEach((s) => {
            if (s.shipment_id == that.shipmentId) {
              var index = that.$root.resentTabs.findIndex(
                (t) => t.shipment_id == that.shipmentId
              );
              that.$root.removeResentTab(index);
            }
          });
          return;
        }
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var par = fun.getParentByProperty(obj, "shipmentId");
        if (!par || par.shipmentId != that.shipmentId) {
          return;
        }
        // console.log(obj.deletedItem);
        switch (obj.tableName) {
          case "charges":
            // that.deleteCharges(obj.deletedItem);
            console.log(obj.table);
            break;
          case "stops":
            that.deleteStop(obj.deletedItem);
            that.refreshWizard();
            break;
          default:
            that.updateTitles();
            break;
        }

        that.submit();
      });
      this.$root.$on("itemSelected", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        that.serviceIndex = obj.index;
        that.updateTitles();
        // console.log(obj);
      });
      this.$root.$on("recordAdded", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.obj.k == "address") {
          obj.rec.isNew = true;
          that.shipmentStops().push(obj.rec);
        }
        // console.log(obj.rec);
      });
      //appendClick
      //edited
      //tableSelectionChanged
      function selectCustomer(obj) {
        var address = fun.clone(that.defaultModel.customer.address);
        obj.selected[0].address = obj.selected[0].address.concat(address);
        that.shipment.customer = obj.selected[0];
        // that.fixAddresses();
        that.getAllLocations();
      }
      this.$root.$on("tableSelectionChanged", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (
          obj.data_object &&
          (obj.data_object.object_name == "v_customer_orders" ||
            obj.data_object.object_name == "customer") &&
          obj.selected[0] &&
          obj.selected[0].address
        ) {
          // if (!obj.selected[0].address.length) {
          //   this.getCustomerAddresses(obj.selected[0]._id, (r) => {
          //     obj.selected[0].address = r;
          //     selectCustomer(obj);
          //   });
          // } else {
          //   selectCustomer(obj);
          // }
          var address = fun.clone(that.defaultModel.customer.address);
          obj.selected[0].address = obj.selected[0].address.concat(address);
          that.shipment.customer = obj.selected[0];
          // that.fixAddresses();
          that.getAllLocations();

          // if (!that.defaultModel.customer.address) {
          // that.shipment.customer.address = address;
          // }

          var customer = that.getWizardStep("customer");
          // that.submit(that.loadModel(customer));
          // that.submit();
          // this.panelIndex = 1;
        }
        if (
          obj.tableName == "department" &&
          obj.selected.length &&
          obj.selected[0]
        ) {
          that.shipment.department_id = obj.selected[0]._id;
          that.shipment.customer_name =
            that.shipment.customer.company +
            " -" +
            obj.selected[0].department_name;
          var wObj = this.getWizardStep("customer");
          var department = that.shipment.customer.department.find((d) => {
            return d._id == that.shipment.department_id;
          });
          wObj.additionalModel = {
            department: department,
          };
          that.addControlKey = !that.addControlKey;

          // that.loadModel(wObj);
        }
      });
      this.$root.$on("tableMounted", (obj) => {
        if (
          obj &&
          obj.parentModel &&
          obj.parentModel.shipment_id != that.shipment.shipment_id
        ) {
          return;
        }
        if (obj.tableName == "department") {
          console.log(obj);
          if (that.shipment.department_id) {
            obj.selected = [];
            obj.selected.push(
              obj.table.find((r) => {
                return r._id == that.shipment.department_id;
              })
            );
          }
          // that.shipment.department_id = obj.selected[0]._id;
        }
        if (obj.tableName == "inventory") {
          that.shipment.inventory = obj.originalRecords;
        }
      });
      this.$root.$on("edited", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
      });
      //linkedObjectSelected
      this.$root.$on("linkedObjectSelected", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        that.defaultModel.customer = obj.data;

        var customer = that.getWizardStep("customer");
        that.submit(that.loadModel(customer));

        // that.formKey = !that.formKey;
        // console.log(obj.data._id);
      });
      //sortingChanged
      this.$root.$on("sortingChanged", (obj) => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        console.log(obj);
        if (obj.label.startsWith("Stops")) {
          var hasOrderChanged = function(array1, array2) {
            const order1 = array1.map((item) => item.stop_number);
            const order2 = array2.map((item) => item.stop_number);

            // Compare the two orders
            if (order1.length !== order2.length) {
              return true; // If the lengths differ, the order has changed
            }

            for (let i = 0; i < order1.length; i++) {
              if (order1[i] !== order2[i]) {
                return true; // If any stop_number differs at the same position
              }
            }

            return false; // The order has not changed
          };
        }
        var array1 = that.currentService.shipment_stop;
        var array2 = obj.localItems;
        if (hasOrderChanged(array1, array2)) {
          that.calculateRoute(that.currentService, that.createMapData);
        }
      });

      this.$root.$on("customBtnClick", (obj) => {
        if (
          obj.tbl &&
          obj.tbl.parentModel.shipment_id != that.shipment.shipment_id
        ) {
          return;
        }
        // if (obj.id == "letters") {
        //   that.letterContainer(obj.item, obj.parent);
        //   return;
        // }

        if (obj.btn) {
          // if (
          //   this.lastBtnClick &&
          //   this.lastBtnClick.btn == obj.btn &&
          //   this.lastBtnClick.id == obj.tbl._uid
          // ) {
          //   return;
          // }
          if (obj.btn == "editContact") {
            that.readOnly = false;
            return;
          }
          if (obj.tbl) {
            this.lastBtnClick = {
              btn: obj.btn,
              id: obj.tbl._uid,
            };
          }
          if (obj.btn == "bookAll") {
            var isBooked =
              that.shipment.estimate["non-binding"].shipment_service[0].booked;

            that.shipment.estimate["non-binding"].shipment_service.forEach(
              (s) => {
                s.booked = !isBooked;
                that.bookService({ model: s });
              }
            );
            that.formKey = !that.formKey;
            //
          }
          if (obj.btn == "customerProfile") {
            console.log(obj.frm.model._id);
            var customerName =
              obj.frm.model.type_of_customer == "commercial"
                ? obj.frm.model.company
                : obj.frm.model.contact.first_name +
                  " " +
                  obj.frm.model.contact.last_name;

            var item = {
              icon: "mdi-account",
              text: "Customer " + customerName,

              link: "/customers/" + obj.frm.model._id,
              customer_id: obj.frm.model._id,

              permitted: true,
            };
            this.$root.addResentTab(item);
          }
        }

        if (
          that._uid == that.$root.shipmentUid &&
          that.$parent.$children.length > 1
        ) {
          var newComp = that.$parent.$children.filter((c) => {
            return c._uid != that.$root.shipmentUid;
          });
          newComp.forEach((c) => {
            if (c.shipmentObject) {
              c.shipmentObject.additionalModel.zone_rate = this.zoneRates;
              // this.updateZoneRates();

              c.zoneFrom = that.zoneFrom;
              c.zoneTo = that.zoneTo;
            }
          });
        }

        if (obj.id == "letters") {
          // that.menuItemClick(obj);
        } else if (obj.id == "status") {
          that.model.shipment_detail.status = obj.item.value;
          this.submit();
          var curStatus = fun.capitalize(
            that.model.shipment_detail ? that.model.shipment_detail.status : ""
          );
          that.statusMenuBtn.color = that.getColor();
          that.statusMenuBtn.title = "Status: " + curStatus;
          that.sendToCallSystem(curStatus);
        } else if (obj.id == "addCojob") {
          obj = this.addCoJob(obj);

          this.addTab(obj);
          this.currentModel = this.getModel(obj);
          // this.currentSchema = this.getSchema();
          that.movePlanKey = !that.movePlanKey;
          //
        } else if (obj.btn == "assignStorage") {
          console.log("assignStorage");
          var assignStorageCmb = obj.tbl.toolBarControls.find((c) => {
            return c.id == "storageList";
          });
          // assignStorageCmb.hidden = false;
          obj.tbl.toolBarKey = !obj.tbl.toolBarKey;
          obj.tbl.selected = [];
          obj.tbl.select = !obj.tbl.select;
          obj.tbl.closeMenuOnClick = !obj.tbl.closeMenuOnClick;
        } else if (obj.tbl) {
          switch (obj.tbl.tableName) {
            //menuItemClick
            case "payroll":
              //refresh_crew
              if (obj.btn == "refresh_crew") {
                // console.log("refresh crew");
                console.log(that.model);
                var itinerary = that.services[that.serviceIndex].itinerary;
                var payroll = that.services[that.serviceIndex].payroll;
                if (!payroll) {
                  payroll = [];
                }
                itinerary.forEach((i) => {
                  if (i.foreman) {
                    var exist = payroll.some((p) => {
                      return p.employee._id == i.foreman._id;
                    });
                    if (!exist) {
                      payroll.push({
                        _id: fun.guid(),
                        payroll_date: fun.formatDate(new Date()),
                        employee: {
                          _id: i.foreman._id,
                          full_name: i.foreman.full_name,
                        },
                        employee_role: "foreman",
                      });
                    }

                    if (i.foreman.crew && i.foreman.crew.crew_employee) {
                      i.foreman.crew.crew_employee.forEach((e) => {
                        exist = payroll.some((p) => {
                          return p.employee._id == e.employee._id;
                        });
                        if (!exist) {
                          payroll.push({
                            _id: fun.guid(),
                            payroll_date: fun.formatDate(new Date()),
                            employee: {
                              _id: e.employee._id,
                              full_name: e.employee.full_name,
                            },
                            employee_role: e.employee_role,
                          });
                        }
                      });
                    }
                  }
                });
              }
              if (obj.btn == "calc_payroll") {
                console.log("calculate payroll");
              }

              break;

            case "charges":
              if (obj.btn == "calc_charges") {
                this.calculate();
              }
              break;
            case "inventory":
              if (
                obj.btn == "visual_inventory" &&
                that.$parent.$router.currentRoute.params.id == that.shipmentId
              ) {
                that.showVisualInventory = true; //!that.showVisualInventory;
              }

              if (obj.btn == "existing_inventory") {
                console.log(obj);
              }

              break;

            default:
              break;
          }
        }
      });
      this.$root.$on("tableChanged", (tbl, keys) => {
        if (
          tbl.parentModel &&
          tbl.parentModel.shipment_id != that.shipment.shipment_id
        ) {
          return;
        }
        // console.log(tbl);

        if (tbl.tableName == "inventory") {
          that.shipment.inventory = tbl.table;
          if (
            that.shipment.inventory.length > 1 ||
            (that.shipment.inventory[0] && that.shipment.inventory[0].volume)
          ) {
            // if (!tbl.edited && !tbl.edited == 0) {
            that.submit();
            // }
          }
        }
        // switch (tbl.tableName) {
        //   case "inventory":
        //     that.calculateInventoryVolume();
        //     that.shipment.inventory = tbl.originalRecords;
        //     var totalVolume = that.shipment.volume ? that.shipment.volume : 0;
        //     tbl.tableHeader = "Tot. Volume: " + totalVolume;

        //     break;
        //   case "payment":
        //     that.shipment.payment = tbl.originalRecords;

        //     break;
        //   case "crm":
        //     that.shipment.crm = tbl.originalRecords;

        //     break;
        //   case "charges":
        //     that.currentModel.estimate_charges = tbl.originalRecords;

        //     that.calculateTotal(that.currentModel);

        //     break;
        //   default:
        //     break;
        // }
      });

      this.$root.$on("radioListPopulated", (r) => {
        var par = fun.getParentByProperty(r, "shipmentId");
        if (
          par.shipment &&
          par.shipment.shipmentId != that.shipment.shipmentId
        ) {
          return;
        }
        console.log(r);
        if (r.objName == "company") {
          if (r.items.length > 1) {
            that.multiCompany = true;
            that.companySelected = false;
            if (that.selectedCompany.shipment_detail) {
              that.shipment.shipment_detail =
                that.selectedCompany.shipment_detail;
            }
          } else {
            that.multiCompany = false;

            if (!that.shipment.shipment_detail) {
              that.shipment.shipment_detail = {
                company: {},
              };
            }
            that.shipment.shipment_detail.company = r.items[0];
            that.companySelected = true;
            // that.lettersReady = true;
            if (that.shipment.shipment_detail.company) {
              that.getLetters(that.shipment.shipment_detail.company._id);
            }
          }

          that.addDefaultShipmentDetail();
        }
      });

      this.$root.$on("labelBtnChanged", (r) => {
        var par = fun.getParentByProperty(obj, "shipmentId");
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (that.currentObject == "shipment_service") {
          var serviceType = r.itemValue;
          var services = that.shipment.estimate["non-binding"].shipment_service;
          var newService = {
            _id: fun.guid(),
            service_type: serviceType,
            apply: true,
            estimate_charges: [],
          };
          services.push(newService);
          // that.shipment.additional_services.push(newService);
          var obj = that.getWizardStep("job");
          that.loadModel(obj);
        }
        if (that.currentStopType) {
          that.currentModel = that.getModel({ obj: that.currentStopType });
          console.log(that.currentModel);
          // that.submit();
          // const customerAddresses = that.shipment.customer.address; // Array of customer addresses
          // const formModel = r.obj.formModel; // Array of form models

          // // Filter objects from formModel where the _id does not match any _id in customerAddresses
          // const newAddress = formModel.address.filter(
          //   (formItem) =>
          //     !customerAddresses.some(
          //       (address) =>
          //         formItem.address_id && address._id != formItem.address_id
          //     )
          // );
          // if (newAddress.length) {
          //   delete newAddress[0].undefined;
          //   that.shipment.customer.address.push(newAddress[0]);
          // }
        }

        // console.log(r.obj.formModel.length);
        // var stopLength = 2;
        // this.addShipmentStop(r.itemValue);
      });
      this.$root.$on("valueChanged", function(r) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (r.key == "booked") {
          console.log(r.model);
          that.bookService(r);
        }

        //
      });
      this.$root.$on("addressChanged", function(addr, obj, oldAddress) {
        var par = fun.getParentByProperty(obj, "shipmentId");
        if (obj.parentModel.shipment_id != that.shipment.shipment_id) {
          return;
        }

        obj.parModel.full_address = addr.address;

        that.addShipmentStop(
          that.currentStopType,
          addr,
          obj.parModel.existing_address &&
            obj.parModel.existing_address.address_id
            ? fun.guid()
            : obj.parModel.address_id,
          obj.parModel
        );
        console.log(addr);
        // that.getModel({obj:"pickup"})

        //
      });
    },
    init() {
      this.$root.shipmentUid = this._uid;
      this.shipmentId = this.$route.params.id
        ? parseInt(this.$route.params.id)
        : "";

      if (!this.shipmentId) {
        //
        this.mapReady = false;
        this.shipment = fun.clone(this.defaultModelClone) || this.defaultModel;

        this.currentModel = null;
        this.currentService = null;
        // try {
        //   this.updateTitles();
        // } catch (error) {
        //   //
        // }

        this.panelIndex = 0;
        if (this.defaultModelClone) {
          this.addDefaultShipmentDetail();
          try {
            this.shipment.shipment_detail.company = this.defaultModel.shipment_detail.company;
          } catch (error) {
            //
          }

          this.currentModel = { customer: this.defaultModelClone.customer };
          this.formKey = !this.formKey;
          // this.currentSchema = this.customerSchema;
        }

        //

        var pickupId = fun.guid();
        var dropoffId = fun.guid();
        this.loadWizard();
        // this.shipment.customer.address[0]._id = pickupId;
        // this.shipment.customer.address[1]._id = dropoffId;
        if (!this.shipmentId) {
          var service = this.shipment.estimate["non-binding"].shipment_service[
            this.serviceIndex
          ];
          service.shipment_stop = [
            {
              // full_address: this.shipment.customer.address[0].full_address,
              value: "pickup",
              text: "pickup",
              title: "pickup",
              use_existing: false,
              stop_number: 1,
              // address_id: this.shipment.customer.address[0]._id,
            },
            {
              // full_address: this.shipment.customer.address[1].full_address,
              value: "dropoff",
              text: "dropoff",
              title: "dropoff",
              use_existing: false,
              stop_number: 2,
              // address_id: this.shipment.customer.address[1]._id,
            },
          ];
          if (this.defaultModelClone) {
            this.updateTitles();
          }
          // this.shipment.stops = service.shipment_stop;
        }
      }
    },
    refreshWizard() {
      const curIndex = this.panelIndex;
      this.panelIndex = -1;
      // this.panelIndex = curIndex;
    },
    selectCompany() {
      this.companySelected = true;
      // this.lettersReady = true;
      this.getLetters(this.shipment.shipment_detail.company._id);
    },
    getEstimateKey(m) {
      var key = "";
      if (!this.shipment) {
        return "non-binding";
      }
      Object.keys(this.shipment.estimate).forEach((k) => {
        if (
          m &&
          fun.getObjects(this.shipment.estimate[k], "_id", m._id).length
        ) {
          key = k;
        }
      });
      return key || "non-binding";
    },
    cleanFullAddress(fullAddress) {
      try {
        return fullAddress.replace(/\([^)]*\)/g, "").trim();
      } catch {
        return fullAddress;
      }
    },

    calculateRoute(model, fn) {
      const uniqueAddresses = fun.getUnique(
        this.combineAddresses(),
        "full_address"
      );

      model.address = uniqueAddresses.filter((item1) => {
        return model.shipment_stop.some((item2) => {
          return (
            item2.address_id === item1._id ||
            item2.full_address === item1.full_address ||
            this.cleanFullAddress(item2.full_address) ==
              this.cleanFullAddress(item1.full_address)
          );
        });
      });
      if (!model.address || (model.address && model.address.length < 2)) {
        this.loading = false;
        this.mapReady = true;
        return;
      }
      model.address.forEach((a) => {
        const m = model.shipment_stop.find((s) => {
          return s.address_id == a._id || s.full_address == a.full_address;
        });
        if (m) {
          a.stop_number = m.stop_number;
        }
      });
      model.address = fun.getUnique(model.address, "full_address");
      model.address.sort((a, b) => a.stop_number - b.stop_number);
      model.shipment_id = this.shipment.shipment_id;
      model.service_index = this.serviceIndex;
      model.estimate_key = this.getEstimateKey(model);

      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true,
        })
        .then((response) => {
          var route = response.data;
          var distance = 0;
          var travelTime = 0;
          if (route && route.leg) {
            route.leg.forEach((l) => {
              distance += l.length;
              travelTime += l.travelTime;
            });
            model.route = route;
            model.distance = distance;
            model.mileage = (distance / 1.6 / 1000).toFixed(0);
            model.driving_time = (travelTime / 3600).toFixed(2);

            this.submit();

            if (fn) {
              fn();
            } else {
              if (route && route.leg) {
                this.submit();
              }
            }
          }

          // console.log(response)
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    applyHandling() {
      this.itemDialog = false;
      this.currentItem.handling = this.currentHandling;

      // this.tableKey = !this.tableKey;
      // this.updateHandling(true);
      this.applyInventoryHandling(this.currentItem, true);
      this.currentItemHandlingId = null;
      this.inventoryTable.table = this.shipment.inventory;
      this.submit();
      this.inventoryTable.scrollToEdited(this.currentItem);
      this.$root.$emit("keepMenu", "add_row");
      // this.inventoryTable.tableKey = !this.inventoryTable.tableKey;

      // this.inventoryTable.menuOpen = true;
    },
    addToMaterials(p, charges, noInventory) {
      var that = this;
      var material = that.additionalModel.material_list.find(
        (item) => item.material_name === p.material_name
      );
      if (material && !noInventory) {
        var materialExists = this.shipment.inventory.find((c) => {
          return c.inventoryId == p._id && c.packingId == p.packingId;
        });
        if (materialExists) {
          materialExists.qty = p.qty;
        } else {
          this.shipment.inventory.push({
            _id: fun.guid(),
            item: material.material_name,
            qty: p.qty,
            inventoryId: p._id,
            packingId: p.packingId,

            room: p.room,
            volume: material.cu_ft,
          });
        }
      }
      if (material && charges) {
        var materialCharge = charges.find(
          (item) =>
            item.charge === material.material_name && item.inventoryId == p._id
        );
        var calcSubtotal = function() {
          var subtotal = 0;
          materialCharge.estimate_rate.forEach((m) => {
            subtotal += m.rate * m.qty || 0;
          });
          return subtotal.toFixed(2);
        };
        var addToCharges = function() {
          var chargeExists = charges.find((c) => {
            return c.inventoryId == p._id && c.packingId == p.packingId;
          });
          if (!chargeExists) {
            charges.push({
              _id: fun.guid(),
              charge_category: "material",
              estimate_rate: materialCharge.estimate_rate,
              charge: material.material_name,
              inventoryId: p._id,
              packingId: p.packingId,
              qty: p.qty,

              // description: i.item,
              subtotal: calcSubtotal(),
            });
          } else {
            chargeExists.qty = p.qty;
            chargeExists.subtotal = calcSubtotal();
          }
        };
        if (materialCharge) {
          var cont = materialCharge.estimate_rate.find(
            (item) => item.rate_name === "cont"
          );
          var pack = materialCharge.estimate_rate.find(
            (item) => item.rate_name === "pack"
          );
          if (cont) {
            cont.qty = parseInt(p.qty || 0);
            pack.qty = parseInt(p.qty || 0);
            materialCharge.subtotal = calcSubtotal();
          } else {
            addToCharges();
          }
        } else {
          materialCharge = {
            estimate_rate: [
              {
                rate_name: "cont",
                rate: material.container_price || 0,
                qty: p.qty,
              },
              {
                rate_name: "pack",
                rate: material.packing_price || 0,
                qty: p.qty,
              },
              {
                rate_name: "unpack",
                rate: material.unpacking_price || 0,
                qty: 0,
              },
            ],
          };
        }
        addToCharges();
      }
    },
    applyInventoryHandling(i, addBoxToInventory) {
      var services = this.shipment.estimate[this.getEstimateKey()]
        .shipment_service;
      if (i.handling) {
        services.forEach((s) => {
          if (!s.estimate_charges) {
            s.estimate_charges = [];
          }
          // var charges = s.estimate_charges;
          Object.keys(i.handling).forEach((key) => {
            if (key == "packing") {
              i.handling.packing.forEach((p) => {
                this.addToMaterials(
                  {
                    _id: i._id,
                    material_name: p.material_name,
                    packingId: p._id,
                    qty: i.qty * p.qty,
                    room: i.room,
                  },
                  s.estimate_charges,

                  addBoxToInventory
                );
              });
            } else if (key != "prompt") {
              var chargeName = fun.capitalize(key) + " - " + i.item;
              var charge = s.estimate_charges.find(
                (item) => item.charge === chargeName
              );

              if (charge) {
                charge.qty = parseInt(i.qty || 0);
                charge.subtotal = i.handling[key] * charge.qty;
              } else {
                s.estimate_charges.push({
                  qty: parseInt(i.qty || 0),
                  subtotal: i.handling[key] * i.qty,
                  estimate_rate: [
                    {
                      rate_name: key,
                      rate: i.handling[key] || 0,
                      qty: i.qty,
                    },
                  ],

                  charge: chargeName,
                  charge_category: "accessorials",
                });
              }
            }
          });
        });
      }
    },

    applyItemMaterials() {
      var service = this.model.estimate[this.getEstimateKey()]
        .shipment_service[0];
      if (!service.estimate_charges) {
        service.estimate_charges = [];
      }
      this.model.inventory.forEach((i) => {
        try {
          if (i.item.startsWith("(CP) ")) {
            this.addToMaterials(
              {
                material_name: i.item.replace("(CP) ", ""),
                qty: i.qty,
                _id: i._id,
              },
              service.estimate_charges,
              {},
              true
            );
          }
          if (i.handling && i.handling.packing) {
            i.handling.packing.forEach((p) => {
              this.addToMaterials(
                {
                  material_name: p.material_name,
                  qty: p.qty * i.qty,
                  packingId: p._id,
                  _id: i._id,
                  room: i.room,
                },
                service.estimate_charges
              );
            });
          }
        } catch (error) {
          //
        }

        // });
      });
    },
    hasInventory(serviceType) {
      return this.additionalModel.service_type.find((t) => {
        return t.service_type == serviceType;
      }).has_inventory;
    },
    canUpdateAddress(address_id) {
      if (this.moreData) {
        const allStops = this.moreData.shipment.flatMap((item) => item.stops);
        if (
          allStops.filter((s) => {
            return s.address_id == address_id;
          }).length > 1
        ) {
          return false;
        }
      }

      // const otherCustomerShipments = this.moreData.shipment.filter((s) => {
      //   return s.shipment_id != this.shipmentId;
      // });
      // otherCustomerShipments.forEach((shipment) => {
      //   if (
      //     shipment.stops.some((s) => {
      //       return s.address_id == address_id;
      //     })
      //   ) {
      //     return false;
      //   }
      // });
      return false;
    },
    deleteStop(deletedItem) {
      this.shipment.estimate["non-binding"].shipment_service[
        this.serviceIndex
      ].shipment_stop = this.shipmentStops().filter((s) => {
        return s._id != deletedItem._id;
      });
      var canDelete = this.canUpdateAddress(deletedItem.address_id);

      if (canDelete) {
        this.shipment.customer.address = this.shipment.customer.address.filter(
          (a) => {
            return a._id != deletedItem.address_id;
          }
        );
      }
      // this.loadModel({obj:deletedItem.value})
      this.currentModel = this.getModel({ obj: deletedItem.value });
    },
    deleteCharges(charges) {
      console.log(charges);
    },
    compareModel() {
      this.lastModified = fun.formatDate(new Date(), false, true);
      var history = "crm";
      this.compareObjects({
        exclude: history,
      });
      try {
        this.originalModel = fun.clone(this.shipment);
        if (!this.shipment[history] || !this.shipment[history].length) {
          this.shipment[history] = [];
        }
        if (!this.shipment.crm) {
          this.shipment.crm = [];
        }

        this.shipment[history] = this.shipment[history].concat(
          this.modifiedRecords
        );
        this.shipment[history] = this.shipment[history].filter(
          (obj, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                obj &&
                t.description === obj.description &&
                t.time_stamp === obj.time_stamp
            )
        );
      } catch (error) {
        //
      }
    },
    compareObjects(par) {
      var lastTimeStamp = fun.formatDate(new Date(), false, true);
      var newObj = par.newObj || this.shipment;
      var oldObj = par.oldObj || this.originalModel;
      var exclude = par.exclude;
      var that = this;
      var arrayKey = par.arrayKey;
      var topObject = null;
      var parKey = "";
      var keys = [];
      if (!par.keys) {
        keys = [];
      } else {
        keys = keys.concat(par.keys);
      }
      var removeWrongKeys = function(v, obj) {
        var cloneKeys = fun.clone(keys);
        cloneKeys.forEach((k) => {
          if (obj && obj[k]) {
            try {
              if (JSON.stringify(obj[k]).indexOf(v) == -1) {
                keys.splice(keys.indexOf(k), 1);
              }
              removeWrongKeys(v, obj[k]);
            } catch (error) {
              //
            }
          }
        });
      };
      var getPath = function(myKey, v, obj) {
        removeWrongKeys(v, obj);
        if (!Array.isArray(obj)) {
          Object.keys(obj).forEach((k) => {
            if (k != exclude && k != "undefined") {
              if (obj[k] && typeof obj[k] == "object") {
                if (JSON.stringify(obj[k]).indexOf(v) != -1) {
                  keys.push(k);
                  getPath(k, v, obj[k]);
                }
              } else if (obj[k]) {
                if (obj[k] == v[k]) {
                  keys.push(k);
                }
              }
            }
          });
        }

        return keys;
      };

      var addtoModified = function(k, type, newValue, oldValue) {
        var v = "";
        if (!newValue) {
          newValue = "";
        }
        if (!oldValue) {
          oldValue = "";
        }
        var newData = newValue.toString().trim();
        var oldData = oldValue.toString().trim();
        var objToSeach = newObj;
        if (oldValue) {
          v = '"' + k + '"' + ":" + '"' + newValue + '"';
          newData = newValue;
        } else {
          v = JSON.stringify(newValue);
          if (type == "value removed") {
            oldData = JSON.stringify(newValue[k]);
            objToSeach = that.originalModel;
          }
        }

        if (type == "record deleted") {
          oldData = JSON.stringify(newValue);
        }
        var dateModified = new Date();

        var fullPath = "";

        if (!arrayKey) {
          fullPath = getPath(k, v, objToSeach);
        } else {
          fullPath = arrayKey;
        }
        if (type == "value added" || type == "record added") {
          newData = "";
        }
        var myPath = fun.clone(fullPath);
        if (arrayKey) {
          myPath = fun.clone(arrayKey);
        }
        if (!myPath) {
          myPath = [];
        }
        myPath.push(k);
        // var changedField = "";
        if (myPath.length > 2) {
          myPath = myPath.splice(myPath.length - 2);
        }
        var flds = [];
        myPath.forEach((p) => {
          // flds.push(fun.capitalize(p));
          flds.push(p);
        });
        try {
          if (k == "company") {
            oldData = that.additionalModel.company.filter((c) => {
              return c._id == oldData;
            })[0].company_name;
            newData = that.additionalModel.company.filter((c) => {
              return c._id == newData;
            })[0].company_name;
          }
        } catch (error) {
          //
        }
        try {
          if (k == "address" && flds.length == 2) {
            var stopType = that.activeTab.obj.obj;

            flds[0] = stopType;
          }
        } catch (error) {
          //
        }
        var capFilds = [];
        flds.forEach((f) => {
          capFilds.push(fun.capitalize(f));
        });

        var description = `${capFilds.join(" ")} changed from ${oldData ||
          "none"} to ${newData || "none"}`;
        var isObject = false;
        try {
          JSON.parse(oldData);
          isObject = true;
        } catch (error) {
          //
        }
        try {
          JSON.parse(newData);
          isObject = true;
        } catch (error) {
          //
        }
        isObject = typeof oldData === "object" && oldData !== null;
        var defaultData = ["origin_address", "destination_address"];
        if (oldData && !isObject && !defaultData.includes(oldData)) {
          var color = that.crmTypes.filter((s) => {
            return s.value == "history";
          })[0].color;
          var modRec = {
            type: k == "status" ? "status" : "history",
            description: description,
            new_data: newData,

            time_stamp: lastTimeStamp,
            user: that.currentUser,
            color: color,
          };
          var exists = that.modifiedRecords.some((r) => {
            return (
              r.description == modRec.description &&
              r.time_stamp == modRec.time_stamp
            );
          });

          if (!exists) {
            // if (lastTimeStamp == that.lastModified) {
            var curRec = that.modifiedRecords.find((m) => {
              return m.time_stamp == that.lastModified && m.type == modRec.type;
            });
            if (curRec) {
              if (!curRec.description.includes(description)) {
                curRec.description += "<br>" + description;
              }
            } else {
              that.modifiedRecords.push(modRec);
            }
          }
        }
      };

      var compareArrays = function(a, b, deleted) {
        if (a && b && Array.isArray(a) && Array.isArray(b)) {
          var status = "record added";
          if (deleted) {
            status = "record deleted";
          }
          var arrSchema = fun.getObjectByKey(that.schema.properties, parKey);
          if (arrSchema) {
            var nameKey = arrSchema.name_key;
          }
          if (!arrayKey) {
            arrayKey = [];
          }
          if (a.length == b.length) {
            status = "record changed";
            a.forEach((r, i) => {
              if (JSON.stringify(r) != JSON.stringify(b[i])) {
                arrayKey = getPath(parKey, JSON.stringify(r), newObj);

                if (nameKey) {
                  arrayKey.push(r[nameKey]);
                }
                try {
                  that.compareObjects({
                    newObj: r,
                    oldObj: b[i],
                    arrayKey: arrayKey,
                    keys: keys,
                  });
                } catch (error) {
                  //
                }
              }
            });
          } else {
            a.forEach((r) => {
              if (
                !b.filter((n) => {
                  return n._id == r._id;
                }).length
              ) {
                arrayKey = getPath(parKey, JSON.stringify(r), newObj);
                if (nameKey) {
                  arrayKey.push(r[nameKey]);
                }
                addtoModified("", status, r);
              }
            });
          }
        }
      };
      var comp = function(a, b) {
        if (Array.isArray(a)) {
          if (a.length >= b.length) {
            compareArrays(a, b);
          } else {
            compareArrays(b, a, true);
          }
        } else {
          if (a && b && Array.isArray(a) == Array.isArray(b)) {
            if (!topObject) {
              topObject = a;
            }
            try {
              var strA = JSON.stringify(a);
              var strTop = JSON.stringify(topObject);
              if (strA != strTop) {
                // object is not top object

                if (strTop.indexOf(strA) == -1) {
                  //object is not child of top object
                  topObject = a;
                }
              }
            } catch (error) {
              //
            }

            var checkingObj = a;
            var comparableObj = b;
            var isKeyRemoved = Object.keys(b).length > Object.keys(a).length;
            if (isKeyRemoved) {
              checkingObj = b;
              comparableObj = a;
            }

            Object.keys(checkingObj).forEach((k) => {
              try {
                if (
                  k != exclude &&
                  k != "_id" &&
                  (!checkingObj.geo || k == "address")
                ) {
                  if (
                    JSON.stringify(checkingObj[k]) !=
                    JSON.stringify(comparableObj[k])
                  ) {
                    parKey = k;
                    // changedKey.push(k);
                    if (typeof checkingObj[k] == "object") {
                      if (comparableObj[k]) {
                        comp(checkingObj[k], comparableObj[k]);
                      } else {
                        var action = "value added";
                        if (isKeyRemoved) {
                          action = "value removed";
                        }

                        addtoModified(k, action, checkingObj);
                      }
                    } else if (Array.isArray(checkingObj[k])) {
                      if (checkingObj[k].length >= comparableObj[k].length) {
                        //new obj added row or row modified
                        checkingObj[k].forEach((r, i) => {
                          if (comparableObj[k][i]) {
                            comp(r, comparableObj[k][i]);
                          } else {
                            addtoModified(k, "record added", r);
                          }
                        });
                      } else {
                        //new obj deleted row
                        comparableObj[k].forEach((r, i) => {
                          if (!checkingObj[k][i]) {
                            comp(r, comparableObj[k][i]);
                          } else {
                            addtoModified(parKey, "record deleted", r);
                          }
                        });
                      }
                    } else {
                      addtoModified(
                        k,
                        "value changed",
                        checkingObj[k],
                        comparableObj[k]
                      );
                    }
                  }
                }
              } catch (error) {
                //
              }
            });
          }
        }
      };

      comp(newObj, oldObj);
    },

    addDefaultShipmentDetail() {
      if (!this.shipment.shipment_detail) {
        this.shipment.shipment_detail = {};
      }
      //
      this.shipment.shipment_detail.sales_person = this.$root.user_id;

      this.shipment.shipment_detail.status = "New";
      this.shipment.shipment_detail.order_date_time = fun.formatDate(
        new Date(),
        false,
        true
      );

      this.addDefaultCRM();
    },
    addTab() {
      var that = this;
      this.$root.resentTabs.filter((t) => {});
      var resentTab = this.$root.resentTabs.find(
        (obj) => obj["text"] === "New Shipment"
      );
      if (resentTab) {
        var customerName =
          that.shipment.customer.customer_name != undefined
            ? that.shipment.customer.customer_name
            : that.shipment.customer.contact.first_name +
              " " +
              that.shipment.customer.contact.last_name;
      }

      if (resentTab) {
        const index = that.$root.resentTabs.findIndex(
          (obj) => obj.link === resentTab.link
        );
        // const newIndex= that.$root.resentTabs.length
        that.$root.removeResentTab(index);
        // }
      }

      that.$root.addResentTab({
        customer_name: customerName,

        shipment_id: that.shipmentId,
      });
    },
    addDefaultCRM() {
      var crm = {
        type: "status",
        description: "New Estimate Created",
        status: "new",
        user: this.$root.user_email,
        time_stamp: fun.formatDate(new Date(), false, true),
      };
      this.shipment.crm = [crm];
    },
    calculateTotal() {
      try {
        var total = 0;
        this.shipment.estimate["non-binding"].shipment_service.forEach((s) => {
          if (s.is_flat_rate) {
            total += parseFloat(s.flat_rate);
          } else {
            s.estimate_charges.forEach((c) => {
              total += parseFloat(c.subtotal || 0);
            });
          }
        });

        this.shipment.total_estimate = total.toFixed(2);
      } catch (error) {
        // console.log(error);
      }
    },
    calculateInventoryVolume() {
      var inventory_volume = fun.calculateInventoryVolume(
        this.shipment.inventory
      );
      this.shipment.num_items = 0;
      this.shipment.inventory.forEach((i) => {
        this.shipment.num_items += parseInt(i.qty || 0);
      });

      this.shipment.volume = inventory_volume
        ? parseFloat(inventory_volume).toFixed(1)
        : 0;
      this.shipment.weight = (inventory_volume * 7).toFixed(1);
    },
    submit(feedback, collapsePanels) {
      var that = this;
      if (this.currentModel && this.currentModel.order_date_time) {
        this.shipment.shipment_detail = this.currentModel;
      }
      try {
        if (this.$refs.form && !this.$refs.form[0].validate()) {
          return;
        }
      } catch (error) {
        //
      }

      var status = this.additionalModel.lead_status.find((s) => {
        return s.status == this.shipment.shipment_detail.status;
      });
      var company = this.additionalModel.company[0];
      try {
        company = this.additionalModel.company.find((c) => {
          return c._id == this.shipment.shipment_detail.company._id;
        });
      } catch (error) {
        //
      }
      if (!company) {
        company = this.additionalModel.company[0];
      }
      var apiCall = "";
      var apiData = null;
      if (status) {
        apiCall = status.api_call;
        apiData = {
          s_id: this.shipment._id,
        };
        apiData = {
          ...apiData,
          ...status,
          ...company,
        };
      }
      this.populateDefaultAddresses();

      this.shipmentStops().forEach((s) => {
        delete s.location;
        if (!s.use_existing) {
          delete s.existing_address;
        }
        // delete s.use_existing;
        //
      });
      if (collapsePanels) {
        this.panelIndex = -1;

        this.mapCols = null;
      }
      delete this.shipment.shipment_service;
      try {
        if (this.shipment.payment.payment) {
          this.shipment.payment = this.shipment.payment.payment;
        }
      } catch (error) {
        //
      }

      this.shipment.customer.address = this.shipment.customer.address.filter(
        (a) => {
          return !a.existing_address;
        }
      );
      try {
        this.shipment.customer.address.forEach((a) => {
          if (a.location && a.location.address && a.location.address.address) {
            a.full_address = a.location.address.address;
            a.location.address.full_address = a.location.address.address;
          }
          delete a.value;
          delete a.use_existing;
        });
      } catch (error) {
        //
      }
      // this.compareModel();
      this.createStops();
      var data = {
        metadata: {
          object_name: "shipment",
          current_user: this.$root.user_email,
          excluded_keys: [
            "history",
            "geo",
            "allLocation",
            "text",
            "title",
            "value",
            "shape",
            "route",
            "address",
            "waypoints",
            "location",
            "warehouse",
          ],
          history_key: "crm",
          update_history: true,
          api_call: apiCall,
          api_data: apiData,
        },
        model: this.shipment,
      };
      this.axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          // console.log(response);
          // this.$nextTick(() => {
          that.modifiedRecords = [];
          this.loadWizard();
          if (!that.shipmentId) {
            that.shipment._id = response.data._id;
            that.shipment.shipment_id = response.data.shipment_id;
            that.shipmentId = response.data.shipment_id;
            that.shipment.customer._id = response.data.customer_id;
            window.location.hash = `#shipment/${that.shipmentId}`;
            var link = "/shipment/" + that.shipmentId;
            that.addTab();
          } else {
            // this.$router.push({ path: "/shipment/" + that.shipmentId });
          }
          var service = this.shipment.estimate["non-binding"].shipment_service[
            this.serviceIndex
          ];
          this.assignCustomerName();
          try {
            if (
              service.shipment_stop[0].full_address &&
              service.shipment_stop[1].full_address
            ) {
              if (!service.service_type) {
                service.service_type = response.data.service_type;
              }

              that.serviceType = fun.capitalize(response.data.service_type);
              if (response.data.service) {
                that.mileage = response.data.service.mileage;
              }
            }
          } catch (error) {
            //
          }

          that.updateTitles();

          if (feedback) {
            feedback();
          }
        });
    },
    expandPanel(obj, noValidate) {
      if (obj) {
        this.mapCols = 12;
        this.modelReady = false;
        this.dialog = false;
        this.currentObject = obj.objectName;
        if (obj.obj == "pickup" || obj.obj == "dropoff") {
          this.currentStopType = obj.obj;
        } else {
          this.currentStopType = "";
        }
        // that.addTab(obj);
        if (obj.obj == "estimate" && this.newShipment) {
          // this.calculate();
          this.loadModel(obj);
          //
        } else {
          this.loadModel(obj);
        }
      } else {
        this.mapCols = null;
      }
      this.updateTitles();
    },
    getTotalPayment() {
      this.totalPayment = 0;
      if (this.shipment.payment && Array.isArray(this.shipment.payment)) {
        this.shipment.payment.forEach((p) => {
          this.totalPayment += parseFloat(p.amount);
        });
      }
      this.totalPayment = this.totalPayment.toFixed(2);
    },
    getTotalEstimate(model) {
      // var estimateKey = model.estimate
      //   ? Object.keys(model.estimate)[0]
      //   : "non-binding";
      var services = this.shipment.estimate["non-binding"].shipment_service;

      this.totalEstimate = 0;
      services.forEach((s) => {
        if (s.estimate_charges) {
          s.total_estimate = s.is_flat_rate
            ? s.flat_rate
            : s.estimate_charges
                .reduce((sum, item) => sum + parseFloat(item.subtotal), 0)
                .toFixed(2);
          if (s.total_estimate && !isNaN(s.total_estimate)) {
            this.totalEstimate += parseFloat(s.total_estimate);
          }
          s.estimate_charges.forEach((c) => {
            if (!c.actual) {
              c.actual = c.subtotal;
            }
          });
          s.total_actual = s.estimate_charges
            .reduce((sum, item) => sum + parseFloat(item.actual), 0)
            .toFixed(2);
        }
      });
      this.balance = this.totalEstimate - this.totalPayment;
      this.balance = this.balance.toFixed(2);
      this.totalEstimate = parseFloat(this.totalEstimate).toFixed(2);

      this.currentService.total_estimate = this.totalEstimate;
      return this.totalEstimate;
      // }
    },
    calculate() {
      var that = this;
      var data = { shipment_id: this.shipmentId };
      this.axios
        .post(this.serverURL + "/calculate_shipment", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response);
          var obj = this.getWizardStep("estimate");
          var estimate = this.getModel(obj);
          // this.currentModel = this.getModel(obj);
          var calculatedCharges = this.fixJson(response.data);
          if (!this.currentService) {
            this.currentService = this.shipment.estimate[
              "non-binding"
            ].shipment_service[this.serviceIndex || 0];
          }
          this.currentService["estimate_charges"] = calculatedCharges.charges;
          if (calculatedCharges.unit_rate) {
            this.currentService.rate = calculatedCharges.unit_rate.rate;
          }

          // that.currentModel = response.data;
          // this.currentModel = {
          //   estimate_charges: this.fixJson(response.data),
          // };

          this.loadModel(obj);
        });
    },
    getIconColor(item) {
      return item.info && item.info != "Not Booked" && item.info != "0.00"
        ? "info"
        : "grey";
    },
    loadModel(obj) {
      this.readOnly = false;
      if ((obj.foremanReadOnly && this.foreman) || this.allReadOnly) {
        this.readOnly = true;
      }
      this.currentModel = this.getModel(obj);

      this.currentSchema = this.getSchema(obj);
      switch (obj.obj) {
        case "additional_services":
          // obj.additionalSchema = {
          //   additional_services: {
          //     type: "object",

          //     "x-display": "d-iterator",
          //     "full-width": true,

          //     hideTitle: true,
          //     hideToolbar: true,
          //     required: null,
          //     properties: {
          //       apply: {
          //         "x-display": "v-switch",
          //         cols: 2,
          //       },
          //       service_date: {
          //         "x-display": "v-date-time",
          //         cols: 8,
          //         // "v-if-parameter": "apply",
          //       },
          //     },
          //     table_properties: {
          //       schema: {
          //         properties: {
          //           apply: {
          //             "x-display": "v-switch",
          //             cols: 2,
          //           },
          //           service_date: {
          //             "x-display": "v-date-time",
          //             cols: 8,
          //             // "v-if-parameter": "apply",
          //           },
          //         },
          //         "v-bind": {
          //           cols_local: 4,
          //           noDelete: true,
          //           hideToolbar: false,
          //           itemAsHeader: "rate_name",
          //         },
          //       },
          //       model: {},

          //       total_records: 0,
          //     },

          //     "v-bind": {
          //       cols_local: 4,
          //       noDelete: true,
          //       hideToolbar: false,
          //       itemAsHeader: "service_type",
          //     },
          //   },
          // };

          obj.model = [];
          this.additionalModel.service_type
            .filter((s) => {
              return s.default_cojob;
            })
            .forEach((j, i) => {
              obj.model[i] = {
                _id: fun.guid(),
                service_type: fun.capitalize(j.service_type),
              };
              // obj.additionalSchema[i] = {
              //   apply: {
              //     "x-display": "v-switch",
              //     cols: 2,
              //     title: fun.capitalize(j.service_type),
              //   },
              //   service_date: {
              //     "x-display": "v-date-time",
              //     cols: 8,
              //     // "v-if-parameter": "apply",
              //   },
              // };
            });
          this.shipment.additional_services = obj.model;
          break;

        case "job":
          obj.additionalModel = {};
          obj.additionalControl = {
            add_option_object: {
              objName: "service_type",
              itemText: "service_type",
              itemValue: "service_type",
              capitalizeText: true,
            },
            // add_btn_title: "Additional Service",

            // addBtnTitle: "Additional Service",
            add_btn_title: "Add Co-Job",
            properties: {},
            add_service: {
              "x-display": "v-label-button",

              "v-bind": {
                noCustomItem: true,
                color: "green",
                addBtn: true,
                noCustomer: true,
                text: true,
                icon: "mdi-shape-square-plus",
                "input-value": "Add Co-Job",
                class: "special-button",
                // add_btn_title: "Additional Service",
              },
            },
          };
          break;
        case "customer_":
          console.log(this.shipment);
          if (
            this.shipment.department_id &&
            this.shipment.customer.department
          ) {
            var department = this.shipment.customer.department.find((d) => {
              return d._id == this.shipment.department_id;
            });
            obj.additionalModel = {
              department: department,
            };
            obj.additionalControl = {
              department: fun.clone(
                this.currentSchema.customer.properties.department
              ),
            };
            var dep = obj.additionalControl.department;
            dep["v-if-parameter"] = "";
            dep["x-display"] = "";
            dep["title"] = "";
            // .customer.properties.contact.properties;
            dep.properties.company = {};
            department.company = this.shipment.customer.company;
            dep.properties.department_name["v-bind"] = { readonly: true };
            dep.properties.company["v-bind"] = { readonly: true };
            Object.keys(dep.properties.contact.properties).forEach((k) => {
              if (!dep.properties.contact.properties[k]["v-bind"]) {
                dep.properties.contact.properties[k]["v-bind"] = {};
              }
              dep.properties.contact.properties[k]["v-bind"].readonly = true;
            });
            this.readOnly = true;
            dep.properties.contact.properties["password"].hidden = true;
            dep.properties.edit = {
              type: "object",
              "x-display": "v-btn",
              id: "editContact",
              hideTitle: true,
              "v-bind": {
                "input-value": "Edit Contact",
                icon: "mdi-pencil",
                item: "customer_id",
                text: true,
              },

              //             "tab": 0,
            };
            this.addControlKey = !this.addControlKey;
          } else {
            this.readOnly = false;
          }
          break;
        default:
          if (this.currentService) {
            this.getTotalEstimate();
            this.getTotalPayment();
          }

          break;
      }

      this.modelReady = true;
      this.formKey = !this.formKey;
    },
    getWizardStep(obj) {
      return (
        this.wizardSteps.find((w) => {
          return w.obj == obj;
        }) || {}
      );
    },
    getLocation(stopType) {
      var stops = this.shipment.estimate[this.getEstimateKey()]
        .shipment_service[0].shipment_stop;
      var st = stops.filter((s) => {
        return s.value == stopType || s.stop_type == stopType;
      })[0];
      var location = this.shipment.customer.address.filter((a) => {
        return st && a.full_address == st.full_address;
      })[0];
      // console.log(location);
      if (!location) {
        location = this.getLocationFromWarehouse(st);
      }

      return location;
    },
    getLocationFromWarehouse(st) {
      var location = {};
      var warehouse = this.additionalModel.warehouse.find((a) => {
        return a.address && a.address.address == st.full_address;
      });
      if (warehouse) {
        var whsAddr = warehouse.address ? warehouse.address.address : "";
        if (warehouse.address) {
          var geo = warehouse.address.geo || warehouse.geo;
          if (geo) {
            location = {
              full_address: whsAddr,
              location: {
                full_address: whsAddr,
                dwelling_type: {
                  dwelling_type: "storage",
                },
                warehouse_id: warehouse._id,
                is_warehouse: true,
                address: {
                  address: whsAddr,

                  geo: {
                    location: {
                      address: geo.location.address || geo.location,
                      position: geo.location.position || geo.position,
                    },
                  },
                },
              },
            };
          }
        }
      }
      return location;
    },
    fixJson(invalidJson) {
      try {
        let validJson = invalidJson
          .replace(/\bTrue\b/g, "true")
          .replace(/\bFalse\b/g, "false")
          .replace(/\bNone\b/g, "null")
          .replace(/'/g, '"') // Replace all single quotes with double quotes.
          .replace(/(\w+):/g, '"$1":'); // Add quotes around keys without quotes.
        // Parse the corrected JSON string.
        let parsed = JSON.parse(validJson);
        return parsed;
      } catch (e) {
        // console.error("Invalid JSON format", e);
      }
    },
    createItinerary(m) {
      if (!m.itinerary || !m.itinerary.length) {
        var itinerary = [];
        var origin = this.getLocation("pickup");
        var destination = this.getLocation("dropoff");
        var warehouseOrig = this.getWarehouse(origin.location);
        var warehouseDest = this.getWarehouse(destination.location);
        var sType = this.additionalModel.service_type.filter((t) => {
          return t.service_type == m.service_type;
        })[0];
        var defaultItinerary = null;
        if (
          sType &&
          sType.default_itinerary &&
          sType.default_itinerary.length
        ) {
          defaultItinerary = {};
          defaultItinerary.default_itinerary = sType.default_itinerary;
        }

        if (!defaultItinerary) {
          defaultItinerary = { default_itinerary: ["d2d"] };
        }
        if (defaultItinerary) {
          defaultItinerary.default_itinerary.forEach((i) => {
            var itineraryStep = {
              _id: fun.guid(),
              step: i,
            };
            var addProperties = {};

            switch (i) {
              case "d2d":
                addProperties = {
                  etd: m.service_date,
                  pickup_status: "booked",
                  delivery_status: "booked",
                  haul_type: "internal",
                  agent: {
                    _id: this.shipment.shipment_detail.company,
                  },
                  crew: {},
                  origin: origin.full_address,
                  destination: destination,
                };
                break;
              case "d2w":
                addProperties = {
                  etd: m.service_date,
                  haul_type: "internal",
                  pickup_status: "booked",
                  delivery_status: "pending",

                  agent: this.getAgent(origin.location),
                  crew: {},
                  origin: origin.full_address,
                };
                if (warehouseOrig) {
                  addProperties.warehouse = {
                    _id: warehouseOrig._id,
                    warehouse_name: warehouseOrig.warehouse_name,
                  };
                }
                break;
              case "w2w":
                addProperties = {
                  // haul_type: "internal",
                  pickup_status: "booked",
                  delivery_status: "pending",

                  crew: {},
                };
                if (warehouseDest) {
                  addProperties.warehouse = {
                    _id: warehouseDest._id,
                    warehouse_name: warehouseDest.warehouse_name,
                  };
                }
                break;
              case "w2d":
                addProperties = {
                  // haul_type: "internal",
                  pickup_status: "booked",
                  delivery_status: "pending",
                  destination: destination.full_address,

                  crew: {},
                };
                if (warehouseOrig) {
                  addProperties.warehouse = {
                    _id: warehouseOrig._id,
                    warehouse_name: warehouseOrig.warehouse_name,
                  };
                }

                break;
            }

            itinerary.push({ ...itineraryStep, ...addProperties });
          });
        }

        m.itinerary = itinerary;
      }
    },
    getAgent(location) {
      var agent = this.additionalModel.agent;

      var curAgent = agent.find(
        (item) =>
          item.zones &&
          item.zones.some(
            (zone) =>
              location &&
              location.carrier_zone &&
              zone._id === location.carrier_zone.zone_id
          )
      );
      return curAgent;
    },
    getWarehouse(location) {
      if (location && location.zone) {
        var warehouse = this.additionalModel.warehouse;
        if (!location.carrier_zone) {
          location.carrier_zone = location.zone;
        }
        var zones = this.additionalModel.zone;
        var curZone = zones.filter((z) => {
          return z._id == location.carrier_zone.zone_id;
        })[0];
        var curWhs;
        if (curZone) {
          if (curZone.default_sit) {
            curWhs = warehouse.filter((w) => {
              return w._id == curZone.default_sit._id;
            })[0];
          } else {
            // curWhs = this.getClosestWhs(location, warehouse);
            curWhs = warehouse.find(
              (item) =>
                item.zones &&
                item.zones.some(
                  (zone) => zone._id === location.carrier_zone.zone_id
                )
            );
          }
        }

        return curWhs;
      }
    },
    getClosestWhs(location, warehouse) {
      var pos = fun.deepFind(location, "address.geo.location.position");
      if (pos) {
        var mileage = 100000;
        var closestWhs = null;
        warehouse.forEach((w) => {
          var whsPos = fun.deepFind(w, "geo.position");
          if (whsPos) {
            var m = fun.mileage(pos[0], pos[1], whsPos[0], whsPos[1]);
            if (parseFloat(m) && parseFloat(m) < mileage) {
              mileage = parseFloat(m);
              closestWhs = w;
            }
          }
        });
      }
      return closestWhs;

      //
    },
    capitalize(s) {
      return fun.capitalize(s);
    },
    updateTitles() {
      var allServices = this.shipment.estimate["non-binding"].shipment_service;
      var services = [this.currentService];
      if (
        this.getWizardStep("itinerary") &&
        // !this.getWizardStep("itinerary").hideIfForeman &&
        !this.foreman &&
        !this.$root.customerId
      ) {
        this.getWizardStep("itinerary").hidden = false;
      }

      // var services = this.shipment.estimate["non-binding"].shipment_service;
      if (this.additionalModel && this.additionalModel.service_type) {
        services.forEach((s) => {
          var serviceType = this.additionalModel.service_type.find((t) => {
            return (
              t.service_type.replace("_", " ").toLowerCase() ==
              s.service_type.replace("_", " ").toLowerCase()
            );
          });
          if (
            this.getWizardStep("itinerary") &&
            serviceType &&
            serviceType.has_itinerary &&
            !this.$root.customerId
          ) {
            this.getWizardStep("itinerary").hidden = false;
          }
          if (serviceType && !serviceType.has_itinerary) {
            this.getWizardStep("itinerary").hidden = true;
          }
        });
      }
      if (this.shipmentId) {
        this.calculateTotal();
      }
      var customerName = this.shipment.customer_name;
      if (!customerName) {
        if (this.shipment.customer?.type_of_customer == "commercial") {
          customerName = this.shipment.customer?.company;
          this.shipment.customer_name = customerName;
        } else {
          customerName =
            this.shipment.customer?.contact?.first_name +
            " " +
            this.shipment.customer?.contact?.last_name;
        }
      }

      this.getWizardStep("customer").info = customerName;

      var addresses = [];
      // var shipmentStops = this.shipment.estimate["non-binding"]
      //   .shipment_service[this.serviceIndex].shipment_stop;
      // if (!this.shipment.stops) {
      //   this.shipment.stops = shipmentStops;
      // }
      var myStops = this.shipmentStops();
      myStops.forEach((s) => {
        if (s.existing_address) {
          s.address_id = s.existing_address.address_id;
        }
      });
      // try {
      //   addresses = fun.innerJoin(
      //     this.combineAddresses(),
      //     myStops,
      //     "_id",
      //     "address_id"
      //   );
      // } catch (error) {
      //   //
      // }
      // if (!addresses.length) {
      //   addresses = fun.innerJoin(
      //     this.combineAddresses(),
      //     myStops,
      //     "_id",
      //     "address_id"
      //   );
      //   // addresses.forEach((a) => {
      //   //   console.log(a);
      //   //   this.shipment.stops
      //   //     .filter((s) => {
      //   //       return s.full_address == a.full_address;
      //   //     })
      //   //     .forEach((b) => {
      //   //       b.address_id = a._id;
      //   //     });
      //   //   shipmentStops = this.shipment.stops;
      //   // });
      // }
      // console.log(addresses);
      const pickups = myStops.filter((a) => {
        return a.value && a.value.includes("pickup");
      });
      const dropoffs = myStops.filter((a) => {
        return a.value && a.value.includes("dropoff");
      });

      var pickupAddresses = [];
      var dropoffAddresses = [];

      pickups.forEach((a) => {
        var c = "";
        if (a.existing_address) {
          pickupAddresses.push(a.existing_address.text);
        } else if (a.full_address) {
          pickupAddresses.push(c + a.full_address);
        }
      });

      dropoffs.forEach((a) => {
        var c = "";
        if (a.warehouse_name) {
          c = a.warehouse_name + " ";
        }
        if (a.existing_address) {
          dropoffAddresses.push(a.existing_address.text);
        } else if (a.full_address) {
          dropoffAddresses.push(c + a.full_address);
        }
      });

      this.getWizardStep("pickup").info =
        // "Pickup: " +
        pickupAddresses.join(", ") || "(not set)";
      if (pickups.length > 1) {
        pickupAddresses = "(" + pickups.length + ") " + pickupAddresses;
        this.getWizardStep("pickup").info = pickupAddresses;
      }

      this.getWizardStep("dropoff").info =
        dropoffAddresses.join(", ") || "(not set)";
      if (dropoffs.length > 1) {
        dropoffAddresses = "(" + dropoffs.length + ") " + dropoffAddresses;
        this.getWizardStep("dropoff").info = dropoffAddresses;
      }

      var totalPayment = 0;
      if (this.shipment.payment && this.shipment.payment.length) {
        this.shipment.payment.forEach((p) => {
          totalPayment += parseFloat(p.amount);
        });
      }
      // this.getWizardStep("order_detail").info =
      //   // "PO Number: " +
      //   this.shipment.shipment_number;
      this.getWizardStep("payment").info =
        // "Payment: " +
        totalPayment.toFixed(2);

      var serviceLabels = [];
      var bookingLabels = "";
      var resourceInfo = [];
      var jobDetail = [];
      if (allServices.length > 3) {
        serviceLabels.push(allServices.length + " Jobs ");
      }
      if (services.length == 1) {
        bookingLabels = services[0].booked ? "Booked" : "Not Booked";
      } else {
        var bookedJobs = services.filter((s) => {
          return s.booked;
        }).length;
        if (bookedJobs) {
          if (bookedJobs == services.length) {
            bookingLabels = "All Booked";
          } else {
            bookingLabels =
              "Booked " + bookedJobs + " out of " + services.length;
          }
        } else {
          bookingLabels = "Not Booked";
        }
      }
      var instr = services[0].special_instructions || "";
      var status = "not scheduled";
      if (services[0].status) {
        status = services[0].status;
      }
      jobDetail.push(
        fun.capitalize(
          // services[0].service_type + ": " +
          "Status: " + status + " " + instr
        )
      );
      allServices.forEach((s, i) => {
        var serviceDate = s.service_date;
        if (i <= 3) {
          if (s.service_date) {
            serviceLabels.push(
              fun.capitalize(s.service_type) +
                " " +
                fun.convertDateFormat(serviceDate)
            );
          }

          var instr = "";
          if (s.special_instructions) {
            instr = " (check instructions)";
          }
          var status = s.status || "";

          if (s.resources && s.resources.length) {
            // this.getWizardStep("itinerary").info = "";
            var res = [];

            s.resources.forEach((r) => {
              if (r.qty) {
                var p = "";
                if (r.qty > 1) {
                  p = "s";
                }
                res.push(r.qty + " " + r.resource_type + p);
              }
            });
            // resourceInfo.push(res.join(", "));
          }
        }
      });
      if (services.length > 3) {
        serviceLabels.push("...");
        resourceInfo.push("...");
        jobDetail.push("...");
      }
      if (services) {
        this.getWizardStep("job").info =
          // "Services: " +
          serviceLabels.join(", ");

        this.getWizardStep("estimate").info = this.getTotalEstimate();

        this.getWizardStep("booking").info = bookingLabels;

        // services.forEach((s) => {

        // });
        this.getWizardStep("resources").info = resourceInfo.join(", ");
        this.getWizardStep("details").info = jobDetail.join(", ");
        var itinerary = services[0].itinerary;
        if (itinerary && itinerary.length) {
          var itineraryInfo = [];
          this.getWizardStep("itinerary").info = "";
          itinerary.forEach((i) => {
            var iInfo = fun.clone(i.step);
            var type = iInfo.split("2");

            var icon = fun.getItineraryIcon(type[0]);
            var icon2 = fun.getItineraryIcon(type[1]);
            iInfo =
              '<span class="large-icon"><i class="mdi mdi-' +
              icon +
              '"></i><i class="mdi mdi-arrow-right-thin"></i><i class="mdi mdi-' +
              icon2 +
              '"></i></span>';
            if (i.day_crew && i.day_crew.crew_name) {
              iInfo += "</br> crew: " + i.day_crew.crew_name;
              if (i.day_crew.resources) {
                iInfo += "<br>";
                i.day_crew.resources.forEach((r) => {
                  if (r.qty && r.qty != "0") {
                    iInfo += " " + r.qty + " " + r.resource_type;
                  }
                });
              }
            }
            if (i.agent && i.agent.contact) {
              iInfo += " agent: " + i.agent.contact.company;
            }
            if (i.trip && i.trip.trip_name) {
              iInfo += " on trip: " + i.trip.trip_name;
            }

            itineraryInfo.push(iInfo + "<br/>");
          });
          this.getWizardStep("itinerary").info = itineraryInfo.join("<br/>");
        }
      }
      if (
        this.shipment.onsite_estimate &&
        this.shipment.onsite_estimate.length
      ) {
        this.getWizardStep("onsite_estimate").info =
          "Onsite Estimate scheduled for " +
          this.shipment.onsite_estimate[0].date_time;
      }

      this.calculateInventoryVolume();
      if (this.shipment.inventory.length) {
        this.getWizardStep("inventory").info =
          // "Inventory: " +
          this.shipment.num_items +
          " items" +
          " Volume: " +
          this.shipment.volume +
          " Weight: " +
          this.shipment.weight;
      } else {
        this.getWizardStep("inventory").info = "(not set)";
      }
    },
    panelDisabled(i) {
      return this.allReadOnly;
      // return !this.enabledPanels.includes(i);
    },
    onAddressChange(addr, obj) {
      var that = this;
      obj.parModel.full_address = addr.address;

      that.addShipmentStop(
        that.currentStopType,
        addr,
        obj.parModel.existing_address &&
          obj.parModel.existing_address.address_id
          ? fun.guid()
          : obj.parModel.address_id,
        obj.parModel
      );
    },
    getSchema(obj) {
      var properties = null;

      var schema = {};
      var key = obj.objectName;
      if (key != "shipment") {
        properties = fun.getObjectByKey(this.schema.properties, key);
      } else {
        properties = fun.clone(this.schema.properties);
      }

      var prop = fun.clone(properties);
      schema[key] = prop;
      var finalSchema = schema[key].properties;
      this.formContainer.readOnly = false;
      switch (key) {
        case "onsite_estimate":
          // case "address":
          finalSchema = schema;
          finalSchema.onsite_estimate["v-bind"].filterTabsFn = null;
          //filterTabsFn
          break;
        case "inventory":
          // case "address":
          finalSchema = schema;

          finalSchema.inventory["v-bind"].hasSearch = false;

          // finalSchema.inventory["v-bind"].toolBarControls.shift();

          break;
        case "address":
          finalSchema = schema;
          finalSchema.address.hidden = false;
          // finalSchema.address.elevation = 0;
          finalSchema.address.add_btn_title = "Add " + obj.obj;
          finalSchema.address["x-display"] = "d-iterator";

          finalSchema.address["v-bind"].tableName = "stops";
          // finalSchema.address["v-bind"].onAddressChange = "onAddressChange";

          finalSchema.address.newValue = obj.obj;

          break;
        case "customer":
          finalSchema = schema;
          // finalSchema.customer.linked_object = null;

          var activeKeys = [
            "type_of_customer",
            "contact",
            "source",
            "link",
            "company",
            "department",
          ];
          var contactKeys = ["first_name", "last_name", "email", "phones"];
          Object.keys(finalSchema.customer.properties).forEach((k) => {
            if (k == "contact") {
              Object.keys(
                finalSchema.customer.properties.contact.properties
              ).forEach((c) => {
                if (!contactKeys.includes(c)) {
                  delete finalSchema.customer.properties.contact.properties[c];
                }
              });
            }
            if (!activeKeys.includes(k)) {
              delete finalSchema.customer.properties[k];
            }
          });

          break;
        case "payment":
          finalSchema = schema;

          break;
        case "itinerary":
          finalSchema = fun.clone(schema);
          var dayCrewProperties =
            finalSchema.itinerary.properties.day_crew.properties;
          delete dayCrewProperties.color;
          delete dayCrewProperties.crew_employee;
          delete dayCrewProperties.crew_truck;
          break;
        case "crm":
          finalSchema = schema;
          finalSchema.crm["v-bind"].parentModel = this.shipment;

          break;
        // case "order_detail":
        //   finalSchema = schema;

        //   break;
        case "attachments":
          finalSchema = schema;
          finalSchema.attachments["v-bind"]._id = this.shipment._id;
          break;
        case "crew_employee":
          finalSchema = fun.clone(schema);
          //    "addBtnTitle": "Add Hours",
          // finalSchema.crew_employee.properties.service_hours.add_btn_title =
          //   "Add Hours";
          // finalSchema.crew_employee["x-display"] = "d-iterator";
          // console.log(finalSchema);
          break;
        case "shipment_service":
        case "details":
        case "resources":
          finalSchema = fun.clone(schema);
          var vBind = finalSchema.shipment_service["v-bind"];
          if (key == "shipment_service" && obj.id != "estimate") {
            vBind.itemAsHeader = ["service_type", "service_date"];
            vBind.defaultIndex = this.serviceIndex;
          } else {
            vBind.itemAsHeader = null;
          }

          switch (obj.obj) {
            case "job":
              vBind.collapsible = false;
              vBind.noDelete = false;
              vBind.toolBarControls = [];
              break;
            case "booking":
              vBind.collapsible = false;
              vBind.noDelete = true;
              break;

            default:
              vBind.collapsible = true;
              vBind.toolBarControls = [];
              vBind.expandedIndex = [0];
              vBind.noDelete = true;
              break;
          }

          Object.keys(finalSchema.shipment_service.properties).forEach((k) => {
            var skip = false;
            if (
              finalSchema.shipment_service.properties[k] &&
              finalSchema.shipment_service.properties[k].portal_id ==
                this.$root.portal_id
            ) {
              if (
                // obj.tab != undefined &&
                obj.tab == finalSchema.shipment_service.properties[k].tab
              ) {
                skip = true;
              }
            }
            obj.onlyFields.forEach((f) => {
              if (
                !obj.onlyFields.includes(k) &&
                finalSchema.shipment_service.properties[k] &&
                !skip
              ) {
                delete finalSchema.shipment_service.properties[k];
                delete finalSchema.shipment_service.table_properties.schema
                  .properties[k];
              }
            });
          });

          console.log("services");
          break;
        default:
          if (obj.onlyFields) {
            Object.keys(finalSchema).forEach((k) => {
              // if (!finalSchema[k]["x-display"]) {
              //   finalSchema[k]["x-display"] = "v-text-field";
              // }
              var skip = false;
              if (
                finalSchema[k] &&
                finalSchema[k].portal_id == this.$root.portal_id
              ) {
                if (
                  // obj.tab != undefined &&
                  obj.tab == finalSchema[k].tab
                ) {
                  skip = true;
                }
              }
              obj.onlyFields.forEach((f) => {
                if (!obj.onlyFields.includes(k) && !skip) {
                  delete finalSchema[k];
                }
              });
            });
          } else {
            finalSchema = fun.mergeObjects(
              schema[key].properties,
              obj.schema || {}
            );
          }

          break;
      }
      if (this.readOnly) {
        try {
          this.formContainer.readOnly = true;
          finalSchema[obj.objectName]["v-bind"].readonly = true;
          finalSchema[obj.objectName]["v-bind"].editRow = false;
        } catch (error) {
          //
        }

        var schemaProperties = fun.getObjectsByKey(finalSchema, "properties");
        schemaProperties.forEach((schema) => {
          Object.keys(schema).forEach((k) => {
            if (!schema[k]["v-bind"]) {
              schema[k]["v-bind"] = {};
            }
            schema[k]["v-bind"].readonly = true;
          });
        });
      }
      // console.log(obj.objectName,fun.getObjectSize(finalSchema))
      this.schemaProperties = fun.extractSchemaPropertiesNested(finalSchema);
      return finalSchema;
    },
    createTasks() {
      if (this.additionalModel.task) {
        var tasks = this.additionalModel.task.filter((t) => {
          return (
            t.lead_status == this.shipment.shipment_detail.status &&
            t.service_type.includes(this.mainService.service_type) &&
            (t.progress_status ==
              this.shipment.shipment_detail.progress_status ||
              !t.progress_status)
          );
        });
        if (tasks.length) {
          tasks.forEach((t) => {
            var dateTime = null;
            switch (t.date_type) {
              case "service_date":
                dateTime = new Date(this.mainService.service_date);
                break;
              case "booked_date":
                dateTime = new Date(this.mainService.booked_date);
                break;
              case "estimate_date":
                if (this.shipment.onsite_estimate.length) {
                  dateTime = new Date(
                    this.shipment.onsite_estimate[
                      this.shipment.onsite_estimate.length - 1
                    ].date_time
                  );
                }

                break;
              case "status_date_changed":
                dateTime = new Date(
                  this.shipment.shipment_detail.status_date_changed
                );
                break;
              default:
                break;
            }
            if (dateTime) {
              dateTime.addDays(parseInt(t.num_days));
            }

            if (t.action.includes("reminder")) {
              this.shipment.crm.push({
                type: "reminder",
                action_date_time: fun.formatDate(dateTime, false, true),
                addressed_to: t.coordinator,
                user: this.currentUser,
                description: t.task_description,
                time_stamp: fun.formatDate(new Date(), false, true),
              });
            }

            //
          });
        }
      }
    },
    bookService(r) {
      this.errorMessage = "";
      var that = this;
      var data = {};

      var msgTitle = "";
      var msg = "";

      // }
      var m = r.model;
      if (m.booked) {
        if (!m.service_date || m.service_date.trim().split(" ").length == 1) {
          m.booked = false;
          this.shipment.shipment_detail.status = "estimate";

          if (!m.service_date) {
            msgTitle = "Date and Time required";
            msg = "Please enter scheduled service date and time";
          } else if (m.service_date.trim().split(" ").length == 1) {
            msgTitle = "Time required";
            msg = "Please enter scheduled service time";
          }

          this.$root.alertDialog(msgTitle, msg);
          return false;
        }
        m.status = "scheduled";
        // if (!m.model.route) {
        if (m.service_type != "international_moving") {
          this.calculateRoute(m);
        }

        // }
        // this.mainService.status = "scheduled";
        this.shipment.booked_estimate = this.getEstimateKey();
        this.shipment.shipment_detail.status = "booked";
        this.mainService.booked = true;
        m.booked_date = fun.formatDate(new Date(), false, true);
        m.booked_by = this.currentUser;
        this.shipment.shipment_detail.status_date_changed = m.booked_date;

        var serviceType = this.additionalModel.service_type.find((t) => {
          return t.service_type == m.service_type;
        });
        // if (serviceType && serviceType.has_itinerary) {
        this.createItinerary(m);
        // }

        this.createTasks();
        // if (!f) {
        this.submit();
        // }

        try {
          // this.refreshModel(this.dataTabs[this.activeTabIndex - 1].obj);
        } catch (error) {
          //
        }
      } else {
        var service_id = m._id;
        // m.model.booked = true;
        m.itinerary = [];
        m.status = "";
        m.book_date = null;
        m.booked_by = "";
        this.shipment.shipment_detail.status = "pending";
        this.shipment.shipment_detail.status_date_changed = fun.formatDate(
          new Date(),
          false,
          true
        );

        // if (!f) {
        this.submit();
      }
    },
    createMapData() {
      var that = this;
      var r = this.currentService;
      that.mapData = [];
      var addMapData = function() {
        that.mapReady = false;
        that.mapData.push({
          shortLabel: "pick",
          label: r.service_date,
          mapLine: {
            service: {
              route: {
                shape: r.route.shape,

                // waypoint: [r.origin.position, r.destination.position],
                waypoint: r.route.waypoint,
                // waypoint: r.route_waypoint,
              },
            },
          },
        });
        that.mapReady = true;
        that.loading = false;
        // that.mapKey = !that.mapKey;
      };
      if (r.route && r.route.leg) {
        addMapData();
      } else {
        this.calculateRoute(r, addMapData);
      }
    },
    addDefaultStops() {
      this.mainService = this.shipment.estimate[
        "non-binding"
      ].shipment_service[0];
      if (this.shipment.estimate["non-binding"].shipment_service.length > 1) {
        this.shipment.estimate["non-binding"].shipment_service.forEach((s) => {
          if (!s.shipment_stop || s.shipment_stop.length == 0) {
            s.shipment_stop = [];
            var curService = this.additionalModel.service_type.find((t) => {
              return t.service_type == s.service_type;
            });
            if (curService) {
              curService.stop_type.forEach((st) => {
                if (st == "origin") {
                  const pickup = this.mainService.shipment_stop.find((p) => {
                    return p.value == "pickup";
                  });
                  s.shipment_stop.push({
                    address_id: pickup.adress_id,
                    full_address: pickup.full_address,
                    existing_address: {
                      address_id: pickup.address_id,
                      text: pickup.full_address,
                      value: pickup.full_address,
                    },
                    value: "pickup",
                    use_existing: true,
                  });
                  //
                }
                if (st == "destination") {
                  const dropoff = this.mainService.shipment_stop.find((p) => {
                    return p.value == "pickup";
                  });
                  s.shipment_stop.push({
                    address_id: dropoff.adress_id,
                    full_address: dropoff.full_address,
                    existing_address: {
                      address_id: dropoff.address_id,
                      text: dropoff.full_address,
                      value: dropoff.full_address,
                    },
                    value: "dropoff",
                    use_existing: true,
                  });
                }
              });
            }
            //
          }
        });
      }
    },
    shipmentStops() {
      var that = this;
      this.addDefaultStops();
      this.currentService = this.shipment.estimate[
        "non-binding"
      ].shipment_service[this.serviceIndex];
      if (this.currentService) {
        var currentStops = this.currentService.shipment_stop;

        this.currentService.shipment_stop.forEach((s) => {
          // s.full_address = this.cleanFullAddress(s.full_address);
          if (s.existing_address) {
            s.full_address;
            s.full_address = s.existing_address.value;
          }
          const addr = this.combineAddresses().find((c) => {
            return (
              (c.full_address &&
                s.full_address &&
                c.full_address.toLowerCase().trim() ==
                  s.full_address.toLowerCase().trim()) ||
              (s.address_id && c._id == s.address_id)
            );
          });
          if (s.full_address && (!s.address_id || !isNaN(s.address_id))) {
            if (addr) {
              s.address_id = addr._id;

              if (!fun.deepFind(addr, "location.address.geo")) {
                this.unparsedAddresses.push({
                  address_id: addr._id,
                  full_address: s.full_address,
                });
              }
            } else {
              const addr = that.combineAddresses().find((c) => {
                return (
                  c.full_address &&
                  s.full_address &&
                  c.full_address.trim() == s.full_address.trim()
                );
              });
              // if (addr) {
              //   s.address_id = addr._id;
              // } else {
              //   const url = "parse_address";

              this.currentStops = this.currentService.shipment_stop;
              if (!this.shipment.stops) {
                this.shipment.stops = [];
              }
              this.currentStops.forEach((c) => {
                if (
                  this.shipment.stops.some((s) => {
                    return c.address_id != s.address_id;
                  })
                ) {
                  this.shipment.stops.push(c);
                }
              });

              return currentStops;
            }
          }
        });

        currentStops = this.currentService.shipment_stop;
        this.shipment.currentStops = currentStops;

        currentStops.forEach((c) => {
          if (
            this.shipment.stops.some((s) => {
              return c.address_id != s.address_id;
            })
          ) {
            this.shipment.stops.push(c);
          }
        });
        // if ((this.serviceIndex == 0 && !this.mapData) || !this.mapData.length) {
        //   this.createMapData();
        // }
      } else {
        this.currentService.shipment_stop = [];
      }
      if (this.unparsedAddresses.length) {
        // this.fixAddresses();
      }
      return currentStops;
    },

    fixAddresses() {
      var that = this;
      this.unparsedAddresses.forEach((s) => {
        axios
          .post(this.serverURL + "/parse_address", {
            address: s.full_address,
            address_id: s.address_id,
          })
          .then((response) => {
            console.log(response.data);

            const address = response.data.location;
            const position = response.data.position;
            // s.full_address = address.label;
            let addr = this.shipment.customer.address.find((a) => {
              return a._id == s.address_id;
            });
            addr.full_address = s.full_address;
            addr.location = {
              full_address: address.label,
              address: {
                address: address.label,
                full_address: address.label,
                geo: {
                  location: {
                    address: address,
                    position: position,
                  },
                },
              },
            };
            let curStop = this.currentService.shipment_stop.find((c) => {
              return c.address_id == s.address_id;
            });
            if (curStop) {
              curStop.full_address = s.full_address;
            }
          });
      });
      this.unparsedAddresses = [];
      this.submit();
    },
    addShipmentStop(type, address, addressId, sStop) {
      // if (!this.shipment.stops) {
      //   this.shipment.stops = [];
      // }

      // var stopLength = this.shipment.stops.length;
      var zones = {};
      if (address) {
        zones = this.findZone(address) || {};
      }
      var title = "";
      //     var shipmentStops = this.shipment.estimate["non-binding"]
      // .shipment_service[this.serviceIndex].shipment_stop;
      var isNewStop = false;
      var isExistingAddress = false;
      if (address) {
        isExistingAddress = this.combineAddresses().some((a) => {
          return a.full_address == address.address;
        });
      } else {
        isExistingAddress = this.combineAddresses().some((a) => {
          return a._id == addressId;
        });
      }
      if (isExistingAddress && address) {
        addressId = this.combineAddresses().find((a) => {
          return a.full_address == address.address;
        })._id;
      }

      // if (!address) {
      //   isExistingAddress = true;
      // }
      // if (!sStop) {
      // var curTypes = this.shipmentStops().filter((s) => {
      //   return s.value == sStop.value;
      // });
      // // if (curTypes.length > 1) {
      isNewStop =
        sStop.isNew ||
        !this.shipmentStops().some((s) => {
          return s._id == sStop._id;
        });

      var stopNumber = 0;
      // var hasType = this.shipmentStops().filter((s) => {
      //   return s.value == sStop.value;
      // });
      // var stN = "";
      if (!addressId) {
        addressId = fun.guid();
      }
      if (!isNewStop) {
        title = type;
        stopNumber = type == "pickup" ? 1 : 2;
        if (!address) {
          //from existing address
          address = this.combineAddresses().find((a) => {
            return a._id == addressId;
          });
        }
        if (!sStop.stop_number) {
          sStop.stop_number = stopNumber;
        }
        if (
          sStop &&
          (!sStop.existing_address ||
            (address && address._id != sStop.existing_address.address_id))
        )
          if (address) {
            sStop.full_address = address.full_address || address.address;
          }

        // if (type && title) {
        //   sStop.title = title;
        // }
      } else {
        // stN = hasType.length + 1;
        // title = type + "_" + stN;

        title = sStop.value;
        if (title && title.includes("pickup")) {
          stopNumber = this.shipmentStops().filter((s) => {
            return s.value && s.value.includes("pickup");
          }).length;
          // stopNumber += 1;
          sStop.stop_number = stopNumber;
          this.shipmentStops()
            .filter((s) => {
              return s.value && s.value.includes("dropoff");
            })
            .forEach((d) => {
              d.stop_number += 1;
            });
        } else {
          stopNumber = this.shipmentStops().length;
          stopNumber += 1;
        }

        if (!sStop.stop_number) {
          sStop.stop_number = stopNumber;
        }
        sStop.address_id = addressId;
        sStop.stop_number = stopNumber;
        if (!sStop.isNew) {
          this.shipmentStops().push(sStop);
        }

        delete sStop.isNew;
      }

      var customerAddress = null;
      if (!isExistingAddress) {
        // addressId = fun.guid();
        sStop.address_id = addressId;
        if (address) {
          sStop.full_address = address.address;
        }

        delete sStop.existing_address;
        var shipmentStop = this.shipmentStops().find((s) => {
          return s._id == sStop._id;
        });
        if (shipmentStop) {
          shipmentStop.full_address = sStop.full_address;
        }
      } else {
        customerAddress = this.shipment.customer.address.find((a) => {
          return a._id == addressId;
        });
      }

      // address.full_address = address.address;

      if (address && !customerAddress && !isExistingAddress) {
        this.shipment.customer.address.push({
          _id: addressId,
          location: {
            full_address: address.address,
            address: address,
            zone: zones.zone,
            carrier_zone: zones.carrier_zone,
          },
        });
      } else if (!isExistingAddress && address) {
        customerAddress.location = {
          full_address: address.address,
          address: address,
          zone: zones.zone,
          carrier_zone: zones.carrier_zone,
        };
      } else if (customerAddress) {
        if (this.canUpdateAddress(addressId)) {
          var custAddress = this.shipment.customer.address.find((a) => {
            return a._id == addressId;
          });
          if (custAddress.full_address != address.full_address) {
            //not used address selected, no need to update
            custAddress.full_address = address.address;
            custAddress.location = {
              full_address: address.address,
              address: address,
              zone: zones.zone,
              carrier_zone: zones.carrier_zone,
            };
          }
        } else {
          addressId = fun.guid();
          sStop.address_id = addressId;
          this.shipment.customer.address.push({
            _id: addressId,
            location: {
              full_address: address.address,
              address: address,
              zone: zones.zone,
              carrier_zone: zones.carrier_zone,
            },
          });
        }
      }
      // if (this.currentService.booked) {
      // ;
      var that = this;
      this.submit((f) => {
        that.currentModel = that.getModel({ obj: sStop.value, allStops: true });
        console.log(that.currentModel);
      });
      // this.calculateRoute(this.currentService, this.createMapData);
    },
    getStatusColor() {
      if (this.additionalModel && this.additionalModel.lead_status) {
        try {
          var status = this.additionalModel.lead_status.find((s) => {
            return (
              this.shipment.shipment_detail &&
              s.status.toLowerCase() ==
                this.shipment.shipment_detail.status.toLowerCase()
            );
          });
          if (status) {
            return status.color || fun.randomColor();
          }
        } catch (error) {
          //
        }
      }
    },
    getServiceColor() {
      if (this.additionalModel && this.additionalModel.service_type) {
        try {
          var service_type = this.additionalModel.service_type.find((s) => {
            return (
              s.service_type.toLowerCase() ==
              this.currentService.service_type.toLowerCase()
            );
          });
          if (service_type) {
            return service_type.color || fun.randomColor();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    getStopNumber(stops, st) {
      var t = st.value.includes("pickup") ? "pickup" : "dropoff";
      var stN = 0;
      stops.forEach((s) => {
        if (s.value.includes(t)) {
          s.stop_number = parseInt(s.stop_number);
          if (parseInt(s.stop_number) > stN) {
            stN = parseInt(s.stop_number);
          }
        }
      });
      st.stop_number = stN + 1;
    },
    panelChange(newPanelIndex) {
      if (!newPanelIndex) {
        this.mapCols = null;
      }
      if (!this.wizardSteps[newPanelIndex]) {
        return false;
      }
      var wizardStep = this.wizardSteps[newPanelIndex].id;
      // console.log(wizardStep);
      if (!this.$refs.form[0].validate()) {
        // Form is not valid, do not change the panel

        this.$nextTick(() => {
          this.panelIndex = newPanelIndex || 0; // Revert to the current panel index
        });

        return false;
      } else {
        // Form is valid, update active panel
        if (!newPanelIndex) {
          this.updateTitles();
        }
        this.panelIndex = newPanelIndex;
        var obj = this.shownSteps[this.panelIndex];
        if (!this.shipment._id) {
          this.submit();
        }
        //
        this.expandPanel(obj);
      }
    },
    combineAddresses() {
      var customerAddresses = this.shipment.customer.address;

      customerAddresses?.forEach((c) => {
        try {
          if (c.full_address) {
            c.full_address = c.full_address.trim();
          }

          if (c.location && c.location.full_address) {
            c.location.full_address = c.location.full_address.trim();
          } else if (!c.location) {
            c.location = {};
          }
        } catch (e) {
          console.log(c);
          console.log(e);
        }

        if (c.existing_address) {
          var isWhs = this.warehouseAddresses.find((w) => {
            return w._id == c.existing_address.address_id;
          });
          if (isWhs) {
            if (!c.location) {
              c.location = {};
            }
            c.location.address = isWhs.address;
          }
        }
      });
      var customerWarehouses = customerAddresses?.filter((c) => {
        return (
          !c.existing_address ||
          !this.warehouseAddresses.filter((w) => {
            return w._id == c.existing_address.address_id;
          }).length
        );
      });
      customerAddresses = customerWarehouses.concat(this.warehouseAddresses);
      return customerAddresses;
    },
    getLocations(stopType) {
      // const shipmentServices = this.shipment.estimate["non-binding"]
      //   .shipment_service;
      // var customerAddresses = this.shipment.customer.address;
      // var warehouseAddresses = fun.clone(this.additionalModel.warehouse);
      // warehouseAddresses.forEach((w) => {
      //   console.log(w);
      //   w.full_address = w.address.address;
      //   w.location = { address: w.address };
      // });
      // customerAddresses = customerAddresses.concat(warehouseAddresses);
      var customerAddresses = this.combineAddresses();
      // var shipmentStops = this.shipment.estimate["non-binding"]
      //   .shipment_service[this.serviceIndex].shipment_stop
      var stops = this.shipmentStops().filter((stop) => {
        if (!stop.value) {
          stop.value = stop.text;
        }
        return stop.value && stop.value.includes(stopType);
      });

      // const addresses = customerAddresses.filter((customerAd)dress) => {
      //   return this.shipment.stops.some(
      //     (stop) => stop.value.includes(stopType)
      //     // ||
      //     // (!stop.value && stop.address_id === customerAddress._id)
      //   );
      // });
      stops.forEach((s) => {
        if (!s.existing_address) {
          s.use_existing = false;
        }
        var addr = customerAddresses.find((a) => {
          return (
            (s.address_id && a._id == s.address_id) ||
            (s.full_address && s.full_address == a.full_address)
          );
        });
        if (addr && !s.existing_address) {
          s.location = addr.location;
        }
        if (!s.location) {
          s.location = {};
        }
        if (!s.location.address && s.full_address) {
          s.location.address = s.full_address;
        }
      });
      var filteredAddresses = customerAddresses.filter((item1) => {
        return stops.some(
          (item2) => item1._id === item2.address_id
          // ||
          // (item1.full_address && item1.full_address === item2.full_address ||  item1.full_address === item2.full_address)
        );
      });
      // if (!filteredAddresses.length) {
      //   filteredAddresses = [{}];
      // }
      return stops;
      // if (!filteredAddresses.length) {
      //   return stops;
      // } else {
      //   var addresses = [];
      //   filteredAddresses.forEach((a) => {
      //     if (a.existing_address) {
      //       a.use_existing = true;
      //     }
      //     var st = stops.find((s) => {
      //       return s.address_id == a._id;
      //     });
      //     if (st) {
      //       a = { ...a, ...st };
      //     }
      //     delete a.warehouse_name;
      //     delete a.zones;
      //     delete a.location;
      //     addresses.push(a);
      //   });
      //   return addresses;
      // }
      // filteredAddresses.forEach((a) => {
      //   if (a.existing_address) {
      //     a.use_existing = true;
      //   }
      //   var st=stops.find(s=>{ return s.address_id==a._id})
      //   if(st){

      //   }
      //   delete a.warehouse_name;
      //   delete a.zones;
      //   delete a.location;
      // });
      // return filteredAddresses;
    },
    getAllLocations() {
      // if (!this.allLocation || !this.allLocation.length) {
      this.allLocation = [];
      this.shipment.customer.address?.forEach((a) => {
        this.allLocation.push({
          address_id: a._id,
          full_address: a.full_address,
          value: "used_address",
          title: "used_address",
          text: "used_address",
        });
      });
      this.warehouseAddresses.forEach((w) => {
        this.allLocation.push({
          full_address: w.full_address,
          value: w.warehouse_name,
          title: w.warehouse_name,
          text: w.warehouse_name,
          address_id: w._id,
          geo: w.geo,
        });
      });
      // if (this.additionalModel && this.additionalModel.warehouse) {
      //   this.additionalModel.warehouse.forEach((w) => {
      //     if (w.address) {
      //       this.allLocation.push({
      //         full_address: w.address.address,
      //         value: w.warehouse_name,
      //         title: w.warehouse_name,
      //         text: w.warehouse_name,
      //         address_id: w._id,
      //         geo: w.geo,
      //       });
      //     }
      //   });
      // }
      // try {
      //   var company = this.additionalModel.company.find((c) => {
      //     return c._id == this.shipment.shipment_detail.company._id;
      //   });
      //   this.allLocation.push({
      //     full_address: company.address.address.address,
      //     title: company.company_name,
      //     value: company.company_name,
      //     text: company.company_name,
      //     address_id: company._id,
      //     geo: company.address.address.geo,
      //   });
      // } catch (error) {
      //   //
      // }

      this.shipment.allLocation = this.allLocation;
      // }
    },
    getModel(t) {
      var model = {};
      //       if (this.shipment.customer) {
      // this.getAllLocations()
      //       }

      switch (t.obj) {
        case "customer":
          model = { customer: this.shipment.customer };
          break;

        case "inventory":
          model = { inventory: this.shipment.inventory };

          break;
        case "onsite_estimate":
          model = { onsite_estimate: this.shipment.onsite_estimate };

          break;
        case "itinerary":
          // model = { inventory: this.shipment.itinerary };
          model = {
            itinerary: this.shipment.estimate["non-binding"].shipment_service[0]
              .itinerary,
          };

          break;
        case "payment":
          model = { payment: this.shipment.payment };

          break;
        case "crm":
          model = { crm: this.shipment.crm };

          break;
        // case "attachments":
        //   model = { attachments: this.shipment.attachments };

        // break;
        case "order_detail":
          model = this.shipment;

          break;
        case "job":
          model = {
            shipment_service: this.shipment.estimate["non-binding"]
              .shipment_service,
          };
          break;
        case "details":
        case "estimate":
        case "resources":
        case "booking":
          model = { shipment_service: [this.currentService] };
          if (t.obj == "resources") {
            model.shipment_service.forEach((s) => {
              if (!s.resources || !s.resources.length) {
                s.resources = [];
                this.additionalModel.vehicle_type
                  .filter((t) => {
                    return t.default;
                  })
                  .forEach((t) => {
                    s.resources.push({
                      resource_type: t.vehicle_type,
                      resource_category: "vehicle",
                    });
                  });
                this.additionalModel.employee_role
                  .filter((t) => {
                    return t.default;
                  })
                  .forEach((t) => {
                    s.resources.push({
                      resource_type: t.employee_role,
                      resource_category: "labor",
                    });
                  });
                this.additionalModel.material_list
                  .filter((t) => {
                    return t.default;
                  })
                  .forEach((t) => {
                    s.resources.push({
                      resource_type: t.material_name,
                      resource_category: "materials",
                    });
                  });
                this.additionalModel.resource_type
                  .filter((t) => {
                    return t.default;
                  })
                  .forEach((t) => {
                    s.resources.push({
                      resource_type: t.resource_type,
                      resource_category: "equipment",
                    });
                  });
              }
            });
          }

          break;
        case "additional_services":
          model = { additional_services: this.shipment.additional_services };

          break;
        case "attachments":
          model = { attachments: [] };

          break;
        // case "estimate":
        //   // model = {
        //   //   estimate_charges: this.shipment.estimate["non-binding"]
        //   //     .shipment_service[0].estimate_charges,
        //   // };
        //   model = this.shipment.estimate["non-binding"].shipment_service[0];

        //   break;
        case "crew_employee":
          if (
            this.currentService.itinerary[0] &&
            this.currentService.itinerary[0].day_crew
          ) {
            model = {
              crew_employee: this.currentService.itinerary[0].day_crew
                .crew_employee,
            };
          }

          break;
        default:
          if (t.obj) {
            if (t.obj.includes("pickup")) {
              model = { address: this.getLocations("pickup") };
            } else if (t.obj.includes("dropoff")) {
              model = { address: this.getLocations("dropoff") };
            } else {
              model = fun.getObjectByKey(this.defaultModel, t.objectName);
            }
          }

          break;
      }

      return model;
    },
  },
  computed: {
    iconSize() {
      const size = this.$vuetify.breakpoint.lgAndUp ? "56px" : "32px";
      return {
        width: size,
        height: size,
      };
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true, // triggers immediately on component creation
      handler(newId, oldId) {
        // if (parseInt(newId)) {
        //   this.shipmentId = parseInt(newId);
        //   this.refreshData();
        // }
        // if (newId == 0) {
        //   this.mount();
        // }
      },
    },
    // currentModel: {
    //   handler: function(newValue, oldValue) {
    //     this.$root.$emit("recalculateFields", this);
    //   },
    //   deep: true,
    //   //this.$root.$emit("recalculateFields", this);
    // },
    selectedCompany() {
      console.log(this.selectedCompany);
    },
    shipment: {
      handler: function(newValue, oldValue) {
        // console.log(newValue);
      },
      deep: true,
    },
    panelIndex() {
      // this.submit();
      this.updateTitles();
      if (this.panelIndex == undefined) {
        this.showPanel(this.defaultDialog);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.main-panel {
  overflow: auto;
}
.panel {
  height: 65vh;
  overflow-y: auto;
  background: #ffffff;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  transition: width 0.3s ease; /* Smooth transition on width change */
}
.service-type {
  text-transform: uppercase;
  background-color: yellow;
  font-size: small;
}
.panel-form {
  /* height: 100%; */
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.close-btn {
  position: absolute;
  right: 0;
  top: 0;
}
.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: transform 0.3s ease;
}

.slide-panel-enter {
  transform: translateX(100%);
}

.slide-panel-leave-to {
  transform: translateX(100%);
}
.blurred {
  filter: blur(4px);
  /* Apply blur effect */
  pointer-events: none;
  /* Prevent interactions with blurred content */
  position: relative;
  /* Ensure the child pseudo-element is positioned correctly */
}

.blurred::after {
  content: "LOADING";
  /* Add the large LOADING text */
  position: absolute;
  /* Position the text over the blurred content */
  top: 50%;
  /* Center vertically */
  left: 50%;
  /* Center horizontally */
  transform: translate(-50%, -50%);
  /* Center the text */
  font-size: 48px;
  /* Set a large font size */
  font-weight: bold;
  /* Make it bold */
  color: rgba(255, 255, 255, 0.8);
  /* White with slight transparency */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  /* Add a shadow for better visibility */
  z-index: 100;
  /* Ensure it appears above the content */
  pointer-events: none;
  /* Prevent interactions with the text */
}

.spinner {
  position: absolute;
  /* Overlay spinner on top of content */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 6px solid rgba(0, 0, 0, 0.1);
  /* Spinner border */
  border-top: 6px solid #3498db;
  /* Spinner highlight */
  border-radius: 50%;
  /* Make it circular */
  width: 40px;
  /* Spinner size */
  height: 40px;
  animation: spin 1s linear infinite;
  /* Spinning animation */
}

.highlight {
  font-weight: bold;
  font-size: larger;

  /* color: blue; */
}

/* .v-item--active .v-btn__content {
  color: cornflowerblue !important;
} */

.v-expansion-panel-header {
  min-height: inherit !important;
  height: 60px !important;
}

.v-expansion-panel-header .col {
  /* color: cornflowerblue; */
  /* text-decoration: underline; */
}

.v-expansion-panel-header .col-1 {
  /* color: cornflowerblue; */
  /* text-decoration: underline; */
  /* width: 10px !important;
  overflow: hidden; */
}

/* .v-expansion-panel-header .v-btn__content {
  color: cornflowerblue;
} */
.v-expansion-panel-content {
  padding: 16px !important;
}

.info-label {
  text-transform: none !important;
  font-weight: normal !important;

  /* font-size: smaller; */
}

.item-title {
  text-transform: none !important;
  font-size: larger;
}

.info-icon {
  height: 50px;
}

.info-title {
  font-size: larger;

  font-weight: normal !important;
}

.dialog {
  background: white;
  height: 100vw;
  /* width: 100vh; */
  overflow-y: auto;
  overflow-x: hidden;
}

.toolbar-dialog {
  /* position: fixed;
  top: 10px;
  right: 10px;
  background-color: transparent; */
}

.custom-round-button {
  width: 60px;
  /* Custom width */
  height: 60px;
  /* Custom height */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.truncate {
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  /* Ensures long words break to fit the container */
  text-align: left;
}

/* @media only screen and (min-width: 900px) { */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

@media only screen and (max-width: 450px) {
  .item-title {
    margin-left: 10px;
    width: 30vw;
    word-wrap: break-word;
    white-space: normal;
    float: left;
    text-align: left;
  }
  .float-container {
    float: right;
    max-width: 40vw; /* Apply max-width here */
  }
  .info-label {
    word-wrap: break-word;
    /* Break long words onto the next line */
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Limits text to 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis; /* Add this line */
  }

  .avatar {
    width: 40px !important; /* default v-avatar size */
    height: 40px !important;
  }
  .dense-tabs .v-tab {
    padding: 0 8px !important; /* smaller horizontal padding */
    height: 32px !important; /* smaller height */
    min-width: 0 !important; /* removes minimum width */
    font-size: 12px !important; /* smaller text */
  }
  .truncate {
    max-width: 140px;
    overflow: visible;
    /* Let the content expand without truncating or scrolling */
    word-wrap: break-word;
    /* Break long words onto the next line */
    white-space: normal;
    /* Allow text to wrap naturally */
    text-align: left;
    /* Align text to the left */
  }
}
</style>
